
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("erUXM", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "DigestsNotificationsPersonalSettingsShell", () => $756bfe95f893dc7f$export$40ac563f4c39c6e6);
$parcel$export(module.exports, "default", () => $756bfe95f893dc7f$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $dGrdR = parcelRequire("dGrdR");

var $4Z5wd = parcelRequire("4Z5wd");

var $90yGq = parcelRequire("90yGq");

var $6s1PB = parcelRequire("6s1PB");

var $beRD7 = parcelRequire("beRD7");

var $l8ruj = parcelRequire("l8ruj");

var $1bQGJ = parcelRequire("1bQGJ");

var $4dRjY = parcelRequire("4dRjY");

var $5rqex = parcelRequire("5rqex");

var $lL5b5 = parcelRequire("lL5b5");

var $9dbF6 = parcelRequire("9dbF6");

var $dtjX2 = parcelRequire("dtjX2");
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
const $756bfe95f893dc7f$var$DigestsNotificationsPersonalSettingsPageLoad = (0, $dGrdR.metrics).pageLoad({
    key: 'personal-settings-digests-notifications',
    ssr: {
        doneAsFmp: true
    }
});
const $756bfe95f893dc7f$export$40ac563f4c39c6e6 = ()=>{
    const accountId = (0, $90yGq.useAccountId)();
    let content;
    if (!accountId) content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lL5b5.default), null);
    else if ((0, $6s1PB.expValEquals)('due_date_notifications_notifications_panel_toggle', 'isEnabled', true)) content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4Z5wd.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5rqex.default), {
        appName: "personal-settings-digests-notifications",
        metric: $756bfe95f893dc7f$var$DigestsNotificationsPersonalSettingsPageLoad,
        isExpectedToHaveSsr: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9dbF6.SubProductUpdater), {
        subProduct: "platform"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dtjX2.DigestsNotificationsPageTitle), null));
    else content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $beRD7.NotFoundErrorPageAsync), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "personal-settings-digests-notifications"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4dRjY.MarkProductStart), null), content);
};
var $756bfe95f893dc7f$export$2e2bcd8739ae039 = (0, $1bQGJ.withRouter)($756bfe95f893dc7f$export$40ac563f4c39c6e6);

});
parcelRegister("4Z5wd", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b186e3d6d251c51$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $iXVV6 = parcelRequire("iXVV6");

var $hiaTb = parcelRequire("hiaTb");
function $9b186e3d6d251c51$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "personalSettingsDigestsNotifications",
        packageName: "jiraPersonalSettingsDigestsNotifications",
        teamName: "frontier"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceName: "personalSettingsDigestsNotifications",
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hiaTb.DigestsNotificationsPage), null)));
}

});
// SCREENS
const $4d5e0871c06cee03$export$f636b5b56f1d624a = 'Screen';
const $4d5e0871c06cee03$export$9d2de6eebf7462b5 = 'Drawer';
const $4d5e0871c06cee03$export$1171103ea9083ffa = 'Modal';
const $4d5e0871c06cee03$export$cae2783c9279926 = 'InlineDialog';
const $4d5e0871c06cee03$export$d1123261ca8831d2 = 'Dropdown';
const $4d5e0871c06cee03$export$238d30785c4bca84 = 'Banner';
const $4d5e0871c06cee03$export$a1562d08625f5d7e = 'UI';
const $4d5e0871c06cee03$export$947dac6c72b26f81 = 'TRACK';
const $4d5e0871c06cee03$export$f1d537d508d2945a = 'SCREEN';
const $4d5e0871c06cee03$export$12346a674644c156 = 'OPERATIONAL';

parcelRegister("hiaTb", function(module, exports) {

$parcel$export(module.exports, "DigestsNotificationsPage", () => $8cf140fa03d6c9d0$export$a5218ffad3974020);

var $aaPf5 = parcelRequire("aaPf5");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $fuUnn = parcelRequire("fuUnn");
var $jbeEq = parcelRequire("jbeEq");

var $bAkIV = parcelRequire("bAkIV");
var $bJcWY = parcelRequire("bJcWY");
var $aZdfU = parcelRequire("aZdfU");

var $dC5iT = parcelRequire("dC5iT");
var $f5TWP = parcelRequire("f5TWP");
var $8CUq3 = parcelRequire("8CUq3");

var $koVbs = parcelRequire("koVbs");

var $cS37j = parcelRequire("cS37j");

var $gEQzr = parcelRequire("gEQzr");

var $1C2yb = parcelRequire("1C2yb");

var $koeKL = parcelRequire("koeKL");

var $coTzA = parcelRequire("coTzA");

var $7iULw = parcelRequire("7iULw");

var $6s1PB = parcelRequire("6s1PB");

var $fpjTq = parcelRequire("fpjTq");

var $6xkfG = parcelRequire("6xkfG");

var $bYMxf = parcelRequire("bYMxf");

var $7hMoX = parcelRequire("7hMoX");

var $9FgOX = parcelRequire("9FgOX");

var $2qfiH = parcelRequire("2qfiH");

var $bPkXX = parcelRequire("bPkXX");

var $c7kve = parcelRequire("c7kve");

var $eCMal = parcelRequire("eCMal");
const $8cf140fa03d6c9d0$export$a5218ffad3974020 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const cloudId = (0, $koeKL.useCloudId)();
    const [expConfig] = (0, $6s1PB.UNSAFE_noExposureExp)('jira_inviter_on_join_notification');
    const [slackExpConfig] = (0, $6s1PB.UNSAFE_noExposureExp)('due-date-notifications-slack-integration');
    const data = (0, $8Uumt.useLazyLoadQuery)((0, $aaPf5.default), {
        cloudId: cloudId
    });
    const emailChannelEnabled = data.jira.notificationGlobalPreference.preferences?.dailyDueDateNotification?.emailChannel?.isEnabled ?? false;
    const inProductChannelEnabled = data.jira.notificationGlobalPreference.preferences?.dailyDueDateNotification?.inProductChannel?.isEnabled ?? false;
    const slackChannelEnabled = data.jira.notificationGlobalPreference.preferences?.dailyDueDateNotification?.slackChannel?.isEnabled ?? false;
    const [isAnyChannelEnabled, setIsAnyChannelEnabled] = (0, $5uXOq.useState)(emailChannelEnabled || inProductChannelEnabled || slackExpConfig.get('isEnabled', 'False') === 'True' && slackChannelEnabled);
    const inviterEmailEnabled = data.jira.notificationGlobalPreference.preferences?.projectInviterNotification?.emailChannel?.isEnabled ?? false;
    const inviterInProductEnabled = data.jira.notificationGlobalPreference.preferences?.projectInviterNotification?.inProductChannel?.isEnabled ?? false;
    const inviterSlackEnabled = data.jira.notificationGlobalPreference.preferences?.projectInviterNotification?.slackChannel?.isEnabled ?? false;
    const [isAnyInviterNotifEnabled, setIsAnyInviterNotifEnabled] = (0, $5uXOq.useState)(inviterEmailEnabled || inviterInProductEnabled || inviterSlackEnabled);
    /* eslint-disable @typescript-eslint/consistent-type-assertions */ const preferences = data.jira.notificationGlobalPreference.preferences;
    /* eslint-enable @typescript-eslint/consistent-type-assertions */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bAkIV.default), {
        testId: "personal-settings-digest-notifications.ui.main"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bJcWY.default), {
        layout: "fixed",
        spacing: "comfortable"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aZdfU.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cS37j.default), {
        breadcrumbs: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jbeEq.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gEQzr.PersonalSettingsBreadcrumbItem), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fuUnn.default), {
            href: (0, $1C2yb.DIGEST_NOTIFICATIONS_PERSONAL_SETTINGS_PATH),
            text: formatMessage((0, $eCMal.default).digestsNotificationsPageTitle)
        })),
        bottomBar: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
            space: "space.050"
        }, formatMessage((0, $eCMal.default).digestsNotificationsExplanation))),
        actions: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $coTzA.FeedbackCollectorButton), {
            entrypointId: (0, $7iULw.ENTRYPOINT_ID_JIRA_PLATFORM),
            feedbackGroupId: "personal-settings-digests"
        })
    }, formatMessage((0, $eCMal.default).digestsNotificationsPageTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), null, formatMessage((0, $eCMal.default).digestsNotificationsControl)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("br", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6xkfG.CombinedPrefDueDateNotification), {
        onToggleChange: setIsAnyChannelEnabled,
        emailPreferenceFragment: preferences,
        inProductPreferenceFragment: preferences,
        slackPreferenceFragment: preferences
    }), isAnyChannelEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        testId: "personal-settings-digest-notifications.ui.box",
        xcss: [
            $8cf140fa03d6c9d0$var$contentWrapperStyles
        ],
        role: "group",
        "aria-labelledby": "due-date-notif-prefs-label"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        id: "due-date-notif-prefs-label",
        xcss: $8cf140fa03d6c9d0$var$preferenceRowStyles
    }, formatMessage((0, $eCMal.default).digestsNotificationsReceiveNotifications)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $8cf140fa03d6c9d0$var$preferenceRowStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bYMxf.EmailPrefDueDateNotification), {
        preferenceFragment: preferences
    })), slackExpConfig.get('isEnabled', 'False') === 'True' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $8cf140fa03d6c9d0$var$preferenceRowStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fpjTq.InProductPrefDueDateNotification), {
        preferenceFragment: preferences
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: [
            $8cf140fa03d6c9d0$var$preferenceRowStyles,
            $8cf140fa03d6c9d0$var$preferenceRowLastStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c7kve.SlackPrefDueDateNotification), {
        preferenceFragment: preferences
    }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: [
            $8cf140fa03d6c9d0$var$preferenceRowStyles,
            $8cf140fa03d6c9d0$var$preferenceRowLastStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fpjTq.InProductPrefDueDateNotification), {
        preferenceFragment: preferences
    }))), expConfig.get('isEnabled', false) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("br", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7hMoX.CombinedInviterNotification), {
        onToggleChange: setIsAnyInviterNotifEnabled,
        emailFragment: preferences,
        inProductFragment: preferences,
        slackFragment: preferences
    }), isAnyInviterNotifEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        testId: "personal-settings-digest-notifications.ui.box",
        xcss: [
            $8cf140fa03d6c9d0$var$contentWrapperStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $8cf140fa03d6c9d0$var$preferenceRowStyles
    }, formatMessage((0, $eCMal.default).digestsNotificationsReceiveNotifications)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $8cf140fa03d6c9d0$var$preferenceRowStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9FgOX.EmailInviterNotification), {
        preferenceFragment: preferences
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: [
            $8cf140fa03d6c9d0$var$preferenceRowStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2qfiH.InProductInviterNotification), {
        preferenceFragment: preferences
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: [
            $8cf140fa03d6c9d0$var$preferenceRowStyles,
            $8cf140fa03d6c9d0$var$preferenceRowLastStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bPkXX.SlackInviterNotification), {
        preferenceFragment: preferences
    })))))));
};
const $8cf140fa03d6c9d0$var$contentWrapperStyles = (0, $8CUq3.xcss)({
    backgroundColor: 'elevation.surface',
    borderWidth: 'border.width',
    borderStyle: 'solid',
    borderColor: 'color.border',
    borderRadius: 'border.radius.100',
    borderTop: 'none',
    borderTopLeftRadius: '0px',
    borderTopRightRadius: '0px',
    paddingRight: 'space.200',
    paddingLeft: 'space.200',
    paddingTop: 'space.150',
    paddingBottom: 'space.150'
});
const $8cf140fa03d6c9d0$var$preferenceRowStyles = (0, $8CUq3.xcss)({
    marginBottom: 'space.100'
});
const $8cf140fa03d6c9d0$var$preferenceRowLastStyles = (0, $8CUq3.xcss)({
    marginBottom: 'space.0'
});

});
parcelRegister("aaPf5", function(module, exports) {

$parcel$export(module.exports, "default", () => $4c74cdd9ce60f63e$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<8c0719812a4405f5c9118a4b3988b39f>>
 * @relayHash 718e597ad464f46a24b791e6bf652462
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8fccef6ab3cb5673806e075732ffd08639dc6ce58f6dcc5a2aa460ff5c6906b8
const $4c74cdd9ce60f63e$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = [
        {
            "kind": "ScalarField",
            "name": "isEnabled"
        }
    ], v3 = {
        "concreteType": "JiraNotificationChannel",
        "kind": "LinkedField",
        "name": "emailChannel",
        "plural": false,
        "selections": v2 /*: any*/ 
    }, v4 = {
        "concreteType": "JiraNotificationChannel",
        "kind": "LinkedField",
        "name": "inProductChannel",
        "plural": false,
        "selections": v2 /*: any*/ 
    }, v5 = {
        "concreteType": "JiraNotificationChannel",
        "kind": "LinkedField",
        "name": "slackChannel",
        "plural": false,
        "selections": v2 /*: any*/ 
    }, v6 = [
        v3 /*: any*/ ,
        v4 /*: any*/ ,
        v5 /*: any*/ 
    ], v7 = {
        "kind": "ScalarField",
        "name": "id"
    }, v8 = [
        v7 /*: any*/ ,
        v3 /*: any*/ ,
        v4 /*: any*/ ,
        v5 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ui_DigestsNotificationsPageQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v1 /*: any*/ ,
                                    "concreteType": "JiraNotificationGlobalPreference",
                                    "kind": "LinkedField",
                                    "name": "notificationGlobalPreference",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraNotificationPreferences",
                                            "kind": "LinkedField",
                                            "name": "preferences",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "combinedPrefDueDateNotif_personalSettingsDigestNotifications_CombinedPrefDueDateNotification_emailPreferenceFragment"
                                                },
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "combinedPrefDueDateNotif_personalSettingsDigestNotifications_CombinedPrefDueDateNotification_inProductPreferenceFragment"
                                                },
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "combinedPrefDueDateNotif_personalSettingsDigestNotifications_CombinedPrefDueDateNotification_slackPreferenceFragment"
                                                },
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "emailPrefDueDateNotif_personalSettingsDigestNotifications_EmailPrefDueDateNotification"
                                                },
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "inProductPrefDueDateNotif_personalSettingsDigestNotifications_InProductPrefDueDateNotification"
                                                },
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "slackPrefDueDateNotif_personalSettingsDigestNotifications_SlackPrefDueDateNotification"
                                                },
                                                {
                                                    "concreteType": "JiraNotificationPreference",
                                                    "kind": "LinkedField",
                                                    "name": "dailyDueDateNotification",
                                                    "plural": false,
                                                    "selections": v6 /*: any*/ 
                                                },
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "combinedInviterNotif_personalSettingsDigestNotifications_CombinedInviterNotification_emailFragment"
                                                },
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "combinedInviterNotif_personalSettingsDigestNotifications_CombinedInviterNotification_inProductFragment"
                                                },
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "combinedInviterNotif_personalSettingsDigestNotifications_CombinedInviterNotification_slackFragment"
                                                },
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "emailInviterNotif_personalSettingsDigestNotifications_EmailInviterNotification"
                                                },
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "inProductInviterNotif_personalSettingsDigestNotifications_InProductInviterNotification"
                                                },
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "slackInviterNotif_personalSettingsDigestNotifications_SlackInviterNotification"
                                                },
                                                {
                                                    "concreteType": "JiraNotificationPreference",
                                                    "kind": "LinkedField",
                                                    "name": "projectInviterNotification",
                                                    "plural": false,
                                                    "selections": v6 /*: any*/ 
                                                }
                                            ]
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "jira.notificationGlobalPreference"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ui_DigestsNotificationsPageQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraNotificationGlobalPreference",
                            "kind": "LinkedField",
                            "name": "notificationGlobalPreference",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraNotificationPreferences",
                                    "kind": "LinkedField",
                                    "name": "preferences",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraNotificationPreference",
                                            "kind": "LinkedField",
                                            "name": "dailyDueDateNotification",
                                            "plural": false,
                                            "selections": v8 /*: any*/ 
                                        },
                                        {
                                            "concreteType": "JiraNotificationPreference",
                                            "kind": "LinkedField",
                                            "name": "dailyDueDateNotification",
                                            "plural": false,
                                            "selections": [
                                                v3 /*: any*/ ,
                                                v4 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                v7 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "concreteType": "JiraNotificationPreference",
                                            "kind": "LinkedField",
                                            "name": "projectInviterNotification",
                                            "plural": false,
                                            "selections": v8 /*: any*/ 
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "8fccef6ab3cb5673806e075732ffd08639dc6ce58f6dcc5a2aa460ff5c6906b8",
            "metadata": {},
            "name": "ui_DigestsNotificationsPageQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$4c74cdd9ce60f63e$var$node.hash = "356cbe93acea3ef0af461e142cbd1e38";
var $4c74cdd9ce60f63e$export$2e2bcd8739ae039 = $4c74cdd9ce60f63e$var$node;

});

parcelRegister("bAkIV", function(module, exports) {

$parcel$export(module.exports, "default", () => $5e769a1b108c1b03$export$2e2bcd8739ae039);

var $cE92Q = parcelRequire("cE92Q");

var $bJcWY = parcelRequire("bJcWY");

var $aZdfU = parcelRequire("aZdfU");
var // Page already has a jsdoc where it is defined
// eslint-disable-next-line @repo/internal/react/require-jsdoc
$5e769a1b108c1b03$export$2e2bcd8739ae039 = (0, $cE92Q.default);

});
parcelRegister("cE92Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $2f4d1a89146de6ed$export$2e2bcd8739ae039);
/* page.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $f1WIN = parcelRequire("f1WIN");
const $2f4d1a89146de6ed$var$styles = {
    banner: "_1bsb1osq _kqsw1n9t",
    bannerContainer: "_16jlkb7n _1o9zidpf _i0dl1wug _v564evma _1bsb1osq _kqswh2mm _1pby11wp",
    pageContent: "_16jlkb7n _1o9zkb7n _i0dl1wug _1ul9idpf _kqswh2mm _1pbykb7n",
    wrapper: "_1e0c1txw _1bsb1osq _1tke1osq _2lx21bp4",
    mainContainer: "_16jlkb7n _1o9zkb7n _i0dl1wug _1e0c1txw",
    navigation: "_kqswh2mm _1pbycs5v"
};
/**
 * __Page__
 *
 * Used to build page layouts.
 *
 * Has built in support for positioning [banners](https://atlassian.design/components/banner/examples)
 * and the deprecated `@atlaskit/navigation`.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/page)
 */ const $2f4d1a89146de6ed$var$Page = ({ isBannerOpen: isBannerOpen = false, bannerHeight: bannerHeight = (0, $f1WIN.defaultBannerHeight), banner: banner, navigation: navigation, children: children, testId: testId })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
        "data-testid": testId,
        className: (0, $bwpsq.default)([
            $2f4d1a89146de6ed$var$styles.wrapper
        ]),
        children: [
            banner ? /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                style: {
                    height: isBannerOpen ? `${bannerHeight}px` : '0'
                },
                "aria-hidden": !isBannerOpen,
                "data-testid": testId ? `${testId}--banner-container` : undefined,
                className: (0, $bwpsq.default)([
                    $2f4d1a89146de6ed$var$styles.bannerContainer
                ]),
                children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                    className: (0, $bwpsq.default)([
                        $2f4d1a89146de6ed$var$styles.banner
                    ]),
                    children: banner
                })
            }) : null,
            /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
                className: (0, $bwpsq.default)([
                    $2f4d1a89146de6ed$var$styles.mainContainer
                ]),
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                        className: (0, $bwpsq.default)([
                            $2f4d1a89146de6ed$var$styles.navigation
                        ]),
                        children: navigation
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                        className: (0, $bwpsq.default)([
                            $2f4d1a89146de6ed$var$styles.pageContent
                        ]),
                        children: children
                    })
                ]
            })
        ]
    });
};
var $2f4d1a89146de6ed$export$2e2bcd8739ae039 = $2f4d1a89146de6ed$var$Page;

});
parcelRegister("f1WIN", function(module, exports) {

$parcel$export(module.exports, "defaultGridColumns", () => $196a11a7b8c2fbef$export$74797698e12f8baa);
$parcel$export(module.exports, "spacingMapping", () => $196a11a7b8c2fbef$export$2a89a65a43bab52d);
$parcel$export(module.exports, "defaultSpacing", () => $196a11a7b8c2fbef$export$8ec7372efd74b753);
$parcel$export(module.exports, "defaultBannerHeight", () => $196a11a7b8c2fbef$export$d77f83c3d17a7b8a);
$parcel$export(module.exports, "defaultMedium", () => $196a11a7b8c2fbef$export$f8725d21f81f3e01);
$parcel$export(module.exports, "defaultLayout", () => $196a11a7b8c2fbef$export$2303d2bd9eeff99a);
const $196a11a7b8c2fbef$var$defaultGridSize = 8;
const $196a11a7b8c2fbef$export$74797698e12f8baa = 12;
const $196a11a7b8c2fbef$export$b8241a1616ab1b96 = $196a11a7b8c2fbef$var$defaultGridSize * 10;
const $196a11a7b8c2fbef$export$2a89a65a43bab52d = {
    comfortable: $196a11a7b8c2fbef$var$defaultGridSize * 5,
    cosy: $196a11a7b8c2fbef$var$defaultGridSize * 2,
    compact: $196a11a7b8c2fbef$var$defaultGridSize * 0.5
};
const $196a11a7b8c2fbef$export$8ec7372efd74b753 = 'cosy';
const $196a11a7b8c2fbef$export$d77f83c3d17a7b8a = 52;
const $196a11a7b8c2fbef$export$f8725d21f81f3e01 = 0;
const $196a11a7b8c2fbef$export$2303d2bd9eeff99a = 'fixed';
const $196a11a7b8c2fbef$export$9ddc3632bbfb8966 = '--ds-columns-num';
const $196a11a7b8c2fbef$export$8b7e31f391e6e681 = '--ds-column-span';
const $196a11a7b8c2fbef$export$936829b4511db3e4 = '--ds-grid-spacing';

});


parcelRegister("bJcWY", function(module, exports) {

$parcel$export(module.exports, "default", () => $08fe944bdcd177c2$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $f1WIN = parcelRequire("f1WIN");

var $itnZ9 = parcelRequire("itnZ9");

var $aZdfU = parcelRequire("aZdfU");

var $ephoW = parcelRequire("ephoW");
/**
 * __Grid__
 *
 * A grid contains one or more `GridColumn` to provide a grid layout.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/page)
 */ const $08fe944bdcd177c2$var$GridWrapper = ({ spacing: spacingProp, columns: columnsProp, layout: layout, testId: testId, children: children, theme: theme })=>{
    /**
	 * isRoot is `true` only in the default context (i.e. no ancestor Grid).
	 */ const { isRoot: isRoot } = (0, $5uXOq.useContext)((0, $ephoW.GridContext));
    const { medium: medium } = (0, $5uXOq.useContext)((0, $aZdfU.GridColumnContext));
    /**
	 * The colspan of the current containing GridColumn provides
	 * the default amount of columns in a nested grid.
	 */ const defaultColumns = medium > 0 ? medium : (0, $f1WIN.defaultGridColumns);
    /**
	 * This is to account for the eventual removal of the `theme` prop. In theory, this should not be exposed.
	 * However, consumers are still using it - there should be a major rerelease with the complete removal of this prop later.
	 */ const spacing = spacingProp ?? theme?.spacing ?? (0, $f1WIN.defaultSpacing);
    const columns = columnsProp ?? theme?.columns ?? defaultColumns;
    const isNested = theme?.isNestedGrid ?? !isRoot;
    const contextValue = (0, $5uXOq.useMemo)(()=>({
            isRoot: false,
            isNested: isNested,
            spacing: spacing,
            columns: columns
        }), [
        spacing,
        columns,
        isNested
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ephoW.GridContext).Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $itnZ9.Grid), {
            layout: layout,
            testId: testId,
            children: children
        })
    });
};
var $08fe944bdcd177c2$export$2e2bcd8739ae039 = $08fe944bdcd177c2$var$GridWrapper;

});
parcelRegister("itnZ9", function(module, exports) {

$parcel$export(module.exports, "Grid", () => $92e4fcbfc398e3a4$export$ef2184bd89960b14);
/* grid.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $f1WIN = parcelRequire("f1WIN");

var $ephoW = parcelRequire("ephoW");
const $92e4fcbfc398e3a4$var$defaultGridColumnWidth = 80;
/**
 * The number of available columns in each row.
 */ const $92e4fcbfc398e3a4$var$varColumnsNum = '--ds-columns-num';
/**
 * The spacing (in `px`) between each column.
 */ const $92e4fcbfc398e3a4$var$varGridSpacing = '--ds-grid-spacing';
const $92e4fcbfc398e3a4$var$styles = {
    grid: "_19pkidpf _2hwx1wug _otyridpf _18u01wug _ca0qidpf _u5f3wx3y _n3tdidpf _19bvwx3y _1e0c1txw _kqswh2mm _4cvr1y6m _1n261g80",
    nestedGrid: "_19pkidpf _2hwx1un2 _otyridpf _18u01un2"
};
const $92e4fcbfc398e3a4$var$gridLayoutMapStyles = {
    fixed: "_p12fgkkb",
    fluid: "_p12f1osq"
};
const $92e4fcbfc398e3a4$export$ef2184bd89960b14 = ({ layout: layout = (0, $f1WIN.defaultLayout), testId: testId, children: children })=>{
    const { isNested: isNested, columns: columns, spacing: spacing } = (0, $5uXOq.useContext)((0, $ephoW.GridContext));
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        style: {
            [$92e4fcbfc398e3a4$var$varColumnsNum]: columns,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [$92e4fcbfc398e3a4$var$varGridSpacing]: `${(0, $f1WIN.spacingMapping)[spacing]}px`
        },
        "data-testid": testId,
        className: (0, $bwpsq.default)([
            $92e4fcbfc398e3a4$var$styles.grid,
            $92e4fcbfc398e3a4$var$gridLayoutMapStyles[layout],
            isNested && $92e4fcbfc398e3a4$var$styles.nestedGrid
        ]),
        children: children
    });
};

});
parcelRegister("ephoW", function(module, exports) {

$parcel$export(module.exports, "GridContext", () => $529bf77650fbff0f$export$11cae3e04ab99fae);

var $5uXOq = parcelRequire("5uXOq");

var $f1WIN = parcelRequire("f1WIN");
const $529bf77650fbff0f$export$11cae3e04ab99fae = /*#__PURE__*/ (0, $5uXOq.createContext)({
    isRoot: true,
    isNested: false,
    spacing: (0, $f1WIN.defaultSpacing),
    columns: (0, $f1WIN.defaultGridColumns)
});

});


parcelRegister("aZdfU", function(module, exports) {

$parcel$export(module.exports, "GridColumnContext", () => $11b791725219e059$export$1229ad7112b989f5);
$parcel$export(module.exports, "default", () => $11b791725219e059$export$2e2bcd8739ae039);
/* grid-column.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $f1WIN = parcelRequire("f1WIN");

var $ephoW = parcelRequire("ephoW");
/**
 * Determines the method by which column width is calculated.
 */ var $11b791725219e059$var$ColumnVariant = /*#__PURE__*/ function(ColumnVariant) {
    /**
   * Column occupies available space.
   *
   * Used when `medium` is 0 (the default).
   */ ColumnVariant["Auto"] = "auto";
    /**
   * Column occupies specified space.
   *
   * Used when 0 < `medium` < `columns`.
   */ ColumnVariant["Bounded"] = "bounded";
    /**
   * Column occupies entire row.
   *
   * Used when `medium` >= `columns`.
   *
   * This case is handled separately because of rounding.
   */ ColumnVariant["FullWidth"] = "fullWidth";
    return ColumnVariant;
}($11b791725219e059$var$ColumnVariant || {});
/**
 * The spacing (in `px`) between each column.
 */ const $11b791725219e059$var$varGridSpacing = '--ds-grid-spacing';
/**
 * The number of columns that a `GridColumn` covers.
 */ const $11b791725219e059$var$varColumnSpan = '--ds-column-span';
/**
 * IE11 and Edge both have rounding issues for flexbox which is why a width of
 * 99.9999% is used. Using 100% here causes columns to wrap prematurely.
 */ const $11b791725219e059$var$singleColumnWidth = `(99.9999% / var(--ds-columns-num))`;
const $11b791725219e059$var$styles = {
    gridColumn: "_19pkidpf _2hwxwx3y _otyridpf _18u0wx3y _1ul9hrtj _16jlkb7n _1o9zidpf _slp31hna"
};
const $11b791725219e059$var$gridColumnWidthMapStyles = {
    auto: "_p12f1ho1 _i0dl1wug",
    bounded: "_p12fpg3g _i0dl1osq",
    fullWidth: "_p12f1ho1 _i0dl1osq"
};
const $11b791725219e059$var$getVariant = ({ medium: medium, columns: columns })=>{
    if (medium === (0, $f1WIN.defaultMedium)) return "auto";
    else if (medium < columns) return "bounded";
    return "fullWidth";
};
const $11b791725219e059$export$1229ad7112b989f5 = /*#__PURE__*/ (0, $5uXOq.createContext)({
    medium: (0, $f1WIN.defaultMedium)
});
/**
 * __Grid column__
 *
 * A grid column can span one or more column positions within a grid.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/page)
 */ const $11b791725219e059$var$GridColumn = ({ medium: medium = (0, $f1WIN.defaultMedium), children: children, testId: testId })=>{
    const { columns: columns } = (0, $5uXOq.useContext)((0, $ephoW.GridContext));
    const contextValue = (0, $5uXOq.useMemo)(()=>({
            medium: medium
        }), [
        medium
    ]);
    /**
   * The real column span,
   * obtained by clamping the passed `medium` value within the allowed range.
   */ const colSpan = Math.max(1, Math.min(medium, columns));
    /**
   * How we should calculate the column width.
   */ const variant = $11b791725219e059$var$getVariant({
        medium: medium,
        columns: columns
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)($11b791725219e059$export$1229ad7112b989f5.Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            style: {
                /**
       * The 'auto' value here isn't actually consumed anywhere and is
       * just to better reflect what is happening when inspecting CSS.
       */ [$11b791725219e059$var$varColumnSpan]: variant === "auto" ? 'auto' : colSpan
            },
            "data-testid": testId,
            className: (0, $bwpsq.default)([
                $11b791725219e059$var$styles.gridColumn,
                $11b791725219e059$var$gridColumnWidthMapStyles[variant]
            ]),
            children: children
        })
    });
};
var $11b791725219e059$export$2e2bcd8739ae039 = $11b791725219e059$var$GridColumn;

});



parcelRegister("gEQzr", function(module, exports) {

$parcel$export(module.exports, "PersonalSettingsBreadcrumbItem", () => $c0b187832616c1cc$export$8d4b46ece371da50);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $fuUnn = parcelRequire("fuUnn");

var $7iULw = parcelRequire("7iULw");

var $coTzA = parcelRequire("coTzA");

var $koVbs = parcelRequire("koVbs");

var $2PRPN = parcelRequire("2PRPN");

const $c0b187832616c1cc$export$fa63c8dd87ea8148 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $coTzA.FeedbackCollectorButton), {
        entrypointId: (0, $7iULw.ENTRYPOINT_ID_JIRA_PLATFORM),
        feedbackGroupId: "personal-settings-sidebar"
    });
const $c0b187832616c1cc$var$TextBreadcrumbItem = /*#__PURE__*/ (0, $5uXOq.forwardRef)((_props, _ref)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c0b187832616c1cc$var$PlainBreadcrumbItem, null, formatMessage((0, $2PRPN.default).personalSettingsBreadcrumb));
});
const $c0b187832616c1cc$export$8d4b46ece371da50 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fuUnn.default), {
        component: $c0b187832616c1cc$var$TextBreadcrumbItem,
        text: ""
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c0b187832616c1cc$var$PlainBreadcrumbItem = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1rjcv77o _kqswh2mm _syaz131l",
            __cmplp.className
        ])
    });
});

});
parcelRegister("coTzA", function(module, exports) {

$parcel$export(module.exports, "FeedbackCollectorButton", () => $85f5e51eda76fbac$export$b39479f42d974760);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fVnbM = parcelRequire("fVnbM");

var $aEHvW = parcelRequire("aEHvW");

var $3bDjY = parcelRequire("3bDjY");

var $koVbs = parcelRequire("koVbs");

var $koeKL = parcelRequire("koeKL");

var $7iULw = parcelRequire("7iULw");

var $dseDh = parcelRequire("dseDh");

var $4uMrp = parcelRequire("4uMrp");
const $85f5e51eda76fbac$var$TooltipWrapper = ({ children: children, appearance: appearance, customLabel: customLabel })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    if (appearance === 'icon') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: customLabel || formatMessage((0, $4uMrp.messages).leaveFeedback),
        position: "top"
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
};
const $85f5e51eda76fbac$export$b39479f42d974760 = ({ buttonAppearance: buttonAppearance = 'normal', testId: testId, icon: Icon = (0, (/*@__PURE__*/$parcel$interopDefault($aEHvW))), feedbackButtonCustomLabel: feedbackButtonCustomLabel, ...feedbackCollectorProps })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const cloudId = (0, $koeKL.useCloudId)();
    const { openFeedbackCollector: openFeedbackCollector } = (0, $dseDh.useFeedbackCollectorActions)();
    const buttonRef = (0, $5uXOq.useRef)(null);
    const onOpen = (0, $5uXOq.useCallback)(()=>{
        // Check if feedbackContext already contains the cloud ID entry
        const hasCloudId = feedbackCollectorProps?.feedbackContext?.some((entry)=>entry.id === (0, $7iULw.EntryKeys).CLOUD_ID);
        // If not, add cloud id to feedback context
        const updatedFeedbackContext = hasCloudId ? feedbackCollectorProps.feedbackContext : [
            ...feedbackCollectorProps.feedbackContext || [],
            {
                id: (0, $7iULw.EntryKeys).CLOUD_ID,
                value: cloudId
            }
        ];
        openFeedbackCollector({
            ...feedbackCollectorProps,
            feedbackContext: updatedFeedbackContext,
            triggerRef: buttonRef
        });
    }, [
        cloudId,
        feedbackCollectorProps,
        openFeedbackCollector
    ]);
    const displayAsLink = buttonAppearance === 'link';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($85f5e51eda76fbac$var$TooltipWrapper, {
        appearance: buttonAppearance,
        customLabel: feedbackButtonCustomLabel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($85f5e51eda76fbac$var$StyledButton, {
        testId: testId,
        ref: buttonRef,
        appearance: displayAsLink ? 'link' : 'subtle',
        isHighlight: buttonAppearance === 'highlight',
        spacing: displayAsLink ? 'none' : 'default',
        onClick: onOpen,
        iconBefore: displayAsLink ? undefined : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Icon, {
            color: buttonAppearance === 'highlight' ? "var(--ds-text-discovery, #5E4DB2)" : "var(--ds-text, #172B4D)",
            label: ""
        }),
        "aria-label": // Only add aria-label if this is an icon button
        buttonAppearance === 'icon' && (feedbackButtonCustomLabel || formatMessage((0, $4uMrp.messages).leaveFeedback)) || '',
        "aria-haspopup": "dialog"
    }, buttonAppearance !== 'icon' && (feedbackButtonCustomLabel || formatMessage((0, $4uMrp.messages).leaveFeedback))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $85f5e51eda76fbac$var$StyledButton = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $fVnbM.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "",
            __cmplp.isHighlight && "_1w901u28 _16hgp7j4 _1fh11u28 _u1mb1jkz _r7smdh45 _1l5a1gfe",
            __cmplp.className
        ])
    });
});

});
parcelRegister("aEHvW", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c129a0bf5d2aeea221ba2044e3fd85fd>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7c1f64cf4f9c421f$var$_react = $7c1f64cf4f9c421f$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $7c1f64cf4f9c421f$var$_feedback = $7c1f64cf4f9c421f$var$_interopRequireDefault((parcelRequire("5dqGX")));

var $7c1f64cf4f9c421f$var$_feedback2 = $7c1f64cf4f9c421f$var$_interopRequireDefault((parcelRequire("3g1Fk")));
function $7c1f64cf4f9c421f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for FeedbackIcon.
 * This component is FeedbackIcon, with `UNSAFE_fallbackIcon` set to "FeedbackIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: customer feedback.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7c1f64cf4f9c421f$var$FeedbackIcon = (props)=>/*#__PURE__*/ $7c1f64cf4f9c421f$var$_react.default.createElement($7c1f64cf4f9c421f$var$_feedback.default, Object.assign({
        LEGACY_fallbackIcon: $7c1f64cf4f9c421f$var$_feedback2.default
    }, props));
$7c1f64cf4f9c421f$var$FeedbackIcon.Name = 'FeedbackIconMigration';
var $7c1f64cf4f9c421f$var$_default = module.exports.default = $7c1f64cf4f9c421f$var$FeedbackIcon;

});
parcelRegister("5dqGX", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f238518c984ab5d0530bd2cff7eccbeb>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3cc2df171aca9493$var$_react = $3cc2df171aca9493$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $3cc2df171aca9493$var$_baseNew = $3cc2df171aca9493$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $3cc2df171aca9493$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Feedback".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: customer feedback.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3cc2df171aca9493$var$FeedbackIcon = (props)=>/*#__PURE__*/ $3cc2df171aca9493$var$_react.default.createElement($3cc2df171aca9493$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6.221l-4.064 2.63A.75.75 0 0 1 1 15V9.5h1.5v4.121l3.093-2A.75.75 0 0 1 6 11.5h7a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5H3a.5.5 0 0 0-.5.5v2.75a.5.5 0 0 0 .5.5h5.44L7.22 5.03l1.06-1.06 2.5 2.5a.75.75 0 0 1 0 1.06l-2.5 2.5-1.06-1.06 1.22-1.22H3a2 2 0 0 1-2-2z" clip-rule="evenodd"/>`
    }, props));
$3cc2df171aca9493$var$FeedbackIcon.displayName = 'FeedbackIcon';
var $3cc2df171aca9493$var$_default = module.exports.default = $3cc2df171aca9493$var$FeedbackIcon;

});

parcelRegister("3g1Fk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $25f4287f17f73dc4$var$_react = $25f4287f17f73dc4$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $25f4287f17f73dc4$var$_feedback = $25f4287f17f73dc4$var$_interopRequireDefault((parcelRequire("5dqGX")));
function $25f4287f17f73dc4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $25f4287f17f73dc4$var$FeedbackIcon = (props)=>/*#__PURE__*/ $25f4287f17f73dc4$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m10.88 5.48-8.43 6.83c-.4.32-.58.96-.41 1.42l.1.27c.17.46.73.83 1.23.82l1.13-.02 6.06-.1 3.65-.06c.51-.01.79-.38.62-.86l-2.92-8.03c-.1-.29-.32-.44-.57-.44a.73.73 0 0 0-.46.18m-5.9 10.46 1.75 4.82a1 1 0 1 0 1.88-.68l-1.54-4.23zm13.71-9.11-2.82 1.03a1 1 0 1 0 .68 1.88l2.82-1.03a1 1 0 1 0-.68-1.88m-1.79 3.85a1 1 0 0 0-.64.77 1 1 0 0 0 .81 1.16l2.96.52a1 1 0 0 0 1.12-1.3l-.02-.05a1 1 0 0 0-.76-.62l-2.95-.52a.97.97 0 0 0-.51.05m-.56-7.65-1.93 2.3a1 1 0 0 0 1.53 1.29l1.93-2.3a1 1 0 0 0-.76-1.64 1 1 0 0 0-.77.36"/></svg>`
    }, props, {
        newIcon: $25f4287f17f73dc4$var$_feedback.default
    }));
$25f4287f17f73dc4$var$FeedbackIcon.displayName = 'FeedbackIcon';
var $25f4287f17f73dc4$var$_default = module.exports.default = $25f4287f17f73dc4$var$FeedbackIcon;

});


parcelRegister("4uMrp", function(module, exports) {

$parcel$export(module.exports, "messages", () => $0c42512912e196d1$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $0c42512912e196d1$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    leaveFeedback: {
        "id": "platform.feedback.feedback-collector.button.leave-feedback",
        "defaultMessage": "Give feedback"
    }
});

});


parcelRegister("2PRPN", function(module, exports) {

$parcel$export(module.exports, "default", () => $6e7d4d450e3a77fc$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $6e7d4d450e3a77fc$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    personalSettingsBreadcrumb: {
        "id": "personal-settings-common.breadcrumb",
        "defaultMessage": "Personal settings"
    }
});

});


parcelRegister("fpjTq", function(module, exports) {

$parcel$export(module.exports, "InProductPrefDueDateNotification", () => $8ca38726c306a5b4$export$9ea941fae6a6f09e);

var $aMxHw = parcelRequire("aMxHw");

var $a9GAO = parcelRequire("a9GAO");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $c0aEF = parcelRequire("c0aEF");

var $2x3Cb = parcelRequire("2x3Cb");

var $kkJfY = parcelRequire("kkJfY");

var $2NMNM = parcelRequire("2NMNM");

var $jDrwg = parcelRequire("jDrwg");

var $koVbs = parcelRequire("koVbs");

var $koeKL = parcelRequire("koeKL");

var $jcw0u = parcelRequire("jcw0u");

var $9InRy = parcelRequire("9InRy");

var $8zOmE = parcelRequire("8zOmE");

var $eCMal = parcelRequire("eCMal");
const $8ca38726c306a5b4$export$9ea941fae6a6f09e = ({ preferenceFragment: preferenceFragment })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const cloudId = (0, $koeKL.useCloudId)();
    const { showErrorFlag: showErrorFlag } = (0, $9InRy.useShowErrorFlag)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const data = (0, $8Uumt.useFragment)((0, $a9GAO.default), preferenceFragment);
    const [commit] = (0, $8Uumt.useMutation)((0, $aMxHw.default));
    const [debouncedHandleToggleChange] = (0, $jDrwg.default)((e, analyticsEventUI)=>{
        const newValue = e.currentTarget.checked;
        (0, $8zOmE.fireUIAnalytics)(analyticsEventUI, 'toggleDueDateNotificationSwitch', {
            isToggleOn: newValue
        });
        commit({
            variables: {
                cloudId: cloudId,
                isEnabled: newValue
            },
            optimisticResponse: {
                jira: {
                    updateGlobalNotificationPreferences: {
                        success: true,
                        errors: [],
                        preferences: {
                            dailyDueDateNotification: {
                                id: data?.dailyDueDateNotification?.id ?? '',
                                inProductChannel: {
                                    isEnabled: newValue
                                }
                            }
                        }
                    }
                }
            },
            onError: (error)=>{
                showErrorFlag();
                (0, $jcw0u.default)({
                    meta: {
                        id: 'mutateInProductPrefDueDateNotification',
                        packageName: 'jiraPersonalSettingsNotificationsDigests',
                        teamName: 'frontier'
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
            },
            onCompleted: (response)=>{
                const errors = response?.jira?.updateGlobalNotificationPreferences?.errors;
                if (errors && errors.length > 0) {
                    showErrorFlag();
                    errors.forEach((error)=>{
                        (0, $jcw0u.default)({
                            meta: {
                                id: 'mutateInProductPrefDueDateNotificationCompletedError',
                                packageName: 'jiraPersonalSettingsNotificationsDigests',
                                teamName: 'frontier'
                            },
                            error: new Error(error?.message || 'Unknown Error'),
                            sendToPrivacyUnsafeSplunk: true
                        });
                    });
                } else (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'mutateInProductPrefDueDateNotification success');
            }
        });
    }, 300, {
        leading: true,
        trailing: true
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2x3Cb.Label), {
        htmlFor: "notify-via-in-product-checkbox"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c0aEF.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kkJfY.default), {
        isChecked: !!data.dailyDueDateNotification?.inProductChannel?.isEnabled,
        onChange: (e, analyticsEventUI)=>debouncedHandleToggleChange(e, analyticsEventUI),
        label: formatMessage((0, $eCMal.default).digestsNotificationsReceiveNotificationsInProduct),
        testId: "personal-settings-digest-notifications.common.ui.in-product-pref-due-date-notif.notify-via-in-product-checkbox"
    })));
};

});
parcelRegister("aMxHw", function(module, exports) {

$parcel$export(module.exports, "default", () => $413d89be7e594365$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<14186e5f6d28d025ea1880a33e606435>>
 * @relayHash 2aa0596b2714e4250257361e64901d01
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f391d92f01f11733617a07e32ab8f160e4f623d9cc74ccf1688e0d08a5bae291
const $413d89be7e594365$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isEnabled"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "fields": [
                {
                    "items": [
                        {
                            "fields": [
                                {
                                    "kind": "Literal",
                                    "name": "channel",
                                    "value": "IN_PRODUCT"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "isEnabled",
                                    "variableName": "isEnabled"
                                },
                                {
                                    "kind": "Literal",
                                    "name": "type",
                                    "value": "DAILY_DUE_DATE_NOTIFICATION"
                                }
                            ],
                            "kind": "ObjectValue",
                            "name": "preferences.0"
                        }
                    ],
                    "kind": "ListValue",
                    "name": "preferences"
                }
            ],
            "kind": "ObjectValue",
            "name": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "inProductPrefDueDateNotificationMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraUpdateGlobalPreferencesPayload",
                            "kind": "LinkedField",
                            "name": "updateGlobalNotificationPreferences",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraNotificationPreferences",
                                    "kind": "LinkedField",
                                    "name": "preferences",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "inProductPrefDueDateNotif_personalSettingsDigestNotifications_InProductPrefDueDateNotification"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "inProductPrefDueDateNotificationMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraUpdateGlobalPreferencesPayload",
                            "kind": "LinkedField",
                            "name": "updateGlobalNotificationPreferences",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraNotificationPreferences",
                                    "kind": "LinkedField",
                                    "name": "preferences",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraNotificationPreference",
                                            "kind": "LinkedField",
                                            "name": "dailyDueDateNotification",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "id"
                                                },
                                                {
                                                    "concreteType": "JiraNotificationChannel",
                                                    "kind": "LinkedField",
                                                    "name": "inProductChannel",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "isEnabled"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "f391d92f01f11733617a07e32ab8f160e4f623d9cc74ccf1688e0d08a5bae291",
            "metadata": {},
            "name": "inProductPrefDueDateNotificationMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$413d89be7e594365$var$node.hash = "f0c222582f335b65480ab3908f3f81ba";
var $413d89be7e594365$export$2e2bcd8739ae039 = $413d89be7e594365$var$node;

});

parcelRegister("a9GAO", function(module, exports) {

$parcel$export(module.exports, "default", () => $87006877d82e6931$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<eab63ffe930f4aae8453a73d33a8ede2>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $87006877d82e6931$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "inProductPrefDueDateNotif_personalSettingsDigestNotifications_InProductPrefDueDateNotification",
    "selections": [
        {
            "concreteType": "JiraNotificationPreference",
            "kind": "LinkedField",
            "name": "dailyDueDateNotification",
            "plural": false,
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "kind": "ScalarField",
                        "name": "id"
                    },
                    "action": "THROW",
                    "path": "dailyDueDateNotification.id"
                },
                {
                    "concreteType": "JiraNotificationChannel",
                    "kind": "LinkedField",
                    "name": "inProductChannel",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isEnabled"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraNotificationPreferences"
};
$87006877d82e6931$var$node.hash = "b4826e9f0dd659f4f46aa7b8ef8045f5";
var $87006877d82e6931$export$2e2bcd8739ae039 = $87006877d82e6931$var$node;

});

parcelRegister("kkJfY", function(module, exports) {

$parcel$export(module.exports, "default", () => $3106eb14f9b0a593$export$2e2bcd8739ae039);
/* checkbox.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $6QvkM = parcelRequire("6QvkM");

var $5JjdN = parcelRequire("5JjdN");

var $kag1C = parcelRequire("kag1C");
var $7xteU = parcelRequire("7xteU");
var $hsLv2 = parcelRequire("hsLv2");
var $e62YQ = parcelRequire("e62YQ");
const $3106eb14f9b0a593$var$checkboxStyles = {
    root: "_19itglyw _nd5lfibj _12ji1r31 _1qu2glyw _12y31o36 _1bsb1osq _4t3i1osq _r06hglyw _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _tzy4idpf _r050fibj _9bg71mn3 _19op11so _a30fhteq _1610e4h9 _13wo93zu _q5a61gyf _8gq114p8 _wje2mov0 _1fo21cni _eyedglyw _1ef7js4s _1h6rjs4s _smzgj3jf _1dk7j3jf _l71j1i6y _t34a1i6y _y32gkivo _1ah9199y _1frj180l _h78e1g3k _dwvb1ps2 _1bok170n _1mhr17cl _fx2i3rva _10oaq2ws _w12s155b _15y61vek _e6ww155b _sg1j1vek _rphw18jz _y9y9mz2b _141bmz2b _255gmz2b _jj67mz2b _swhgmz2b _axq81diq _1jiz1diq _s9051diq _1efy1diq _1oav1diq _10y313gf _1wt913gf _qq8613gf _1adw13gf _12sr13gf _16jiglyw _693jglyw _1niqglyw _cl9tglyw _1jbnglyw _j1ta1hou _18qu1ps2 _1g52170n _1log17cl _32hzmz2b _1vv91diq _yjhd1hou _w1cowc43 _jdqn1onz _4y4t1onz _lvfrwc43 _g68dwc43 _13dk1onz _w1el1onz _a9yw1onz _1l3g1onz _dcdpgir2 _wobcgir2 _rp9wgir2 _9ebfwc43 _e43iwc43 _1tkuwc43 _1lehwc43 _b9q3wc43 _tu2918qt _1uxv18qt _1ufw18qt _opo918qt _1e8318qt _1k3d18qt _25yv18qt _1igz18qt _c7cc18qt _1swg18qt"
}; /**
    * __Checkbox__
    *
    * A checkbox an input control that allows a user to select one or more options from a number of choices.
    *
    * - [Examples](https://atlassian.design/components/checkbox/examples)
    * - [Code](https://atlassian.design/components/checkbox/code)
    * - [Usage](https://atlassian.design/components/checkbox/usage)
    */ 
const $3106eb14f9b0a593$var$Checkbox = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(function Checkbox({ isChecked: isCheckedProp, isDisabled: isDisabled = false, isInvalid: isInvalid = false, defaultChecked: defaultChecked = false, isIndeterminate: isIndeterminate = false, onChange: onChangeProps, analyticsContext: analyticsContext, label: label, name: name, value: value, isRequired: isRequired, testId: testId, xcss: xcss, className: className, ...rest }, ref) {
    const [isCheckedState, setIsCheckedState] = (0, $5uXOq.useState)(isCheckedProp !== undefined ? isCheckedProp : defaultChecked);
    const onChange = (0, $5uXOq.useCallback)((e, analyticsEvent)=>{
        setIsCheckedState(e.target.checked);
        if (onChangeProps) onChangeProps(e, analyticsEvent);
    }, [
        onChangeProps
    ]);
    const onChangeAnalytics = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        componentName: 'checkbox',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    const internalRef = (0, $5uXOq.useRef)(null);
    const mergedRefs = (0, $5JjdN.default)([
        internalRef,
        ref
    ]); // Use isChecked from the state if it is controlled
    const isChecked = isCheckedProp === undefined ? isCheckedState : isCheckedProp;
    (0, $5uXOq.useEffect)(()=>{
        if (internalRef.current) internalRef.current.indeterminate = isIndeterminate;
    }, [
        isIndeterminate
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $7xteU.default), {
        isDisabled: isDisabled,
        label: label,
        id: rest.id ? `${rest.id}-label` : undefined,
        testId: testId && `${testId}--checkbox-label`,
        // When there is more usage of this pattern we'll update the lint rule.
        xcss: xcss,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("input" // It is necessary only for Safari. It allows to render focus styles.
            , {
                tabIndex: 0,
                ...rest,
                type: "checkbox",
                ref: mergedRefs,
                disabled: isDisabled,
                checked: isChecked,
                value: value,
                name: name,
                required: isRequired,
                className: (0, $bwpsq.default)([
                    $3106eb14f9b0a593$var$checkboxStyles.root,
                    className
                ]),
                onChange: onChangeAnalytics,
                "aria-invalid": isInvalid ? 'true' : undefined,
                "data-testid": testId && `${testId}--hidden-checkbox`,
                "data-invalid": isInvalid ? 'true' : undefined
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kag1C.default), {
                isIndeterminate: isIndeterminate,
                isChecked: isChecked
            }),
            label && /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $hsLv2.default), {
                children: [
                    label,
                    isRequired && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $e62YQ.default), {})
                ]
            })
        ]
    });
}));
$3106eb14f9b0a593$var$Checkbox.displayName = 'Checkbox';
var $3106eb14f9b0a593$export$2e2bcd8739ae039 = $3106eb14f9b0a593$var$Checkbox;

});
parcelRegister("kag1C", function(module, exports) {

$parcel$export(module.exports, "default", () => $a0746a27410bc168$export$2e2bcd8739ae039);
/* checkbox-icon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $dV6Te = parcelRequire("dV6Te");

var $VSDnB = parcelRequire("VSDnB");
function $a0746a27410bc168$var$getIcon(isIndeterminate, isChecked) {
    if (isIndeterminate) {
        // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
        if ((0, $VSDnB.fg)('platform-visual-refresh-icons')) return /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M7.75 12.75H16.25V11.25H7.75V12.75Z",
            fill: "inherit"
        });
        else return /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
            fill: "inherit",
            x: "8",
            y: "11",
            width: "8",
            height: "2",
            rx: "1"
        });
    }
    if (isChecked) {
        // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
        if ((0, $VSDnB.fg)('platform-visual-refresh-icons')) return /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M16.3262 9.48011L15.1738 8.51984L10.75 13.8284L8.82616 11.5198L7.67383 12.4801L10.1738 15.4801C10.3163 15.6511 10.5274 15.75 10.75 15.75C10.9726 15.75 11.1837 15.6511 11.3262 15.4801L16.3262 9.48011Z",
            fill: "inherit"
        });
        else return /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
            d: "M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586l-1.293-1.293z",
            fill: "inherit"
        });
    }
    // No icon
    return null;
}
/**
 * __Checkbox icon__
 *
 * A checkbox icon is the visual representation of checkbox state,
 * which is shown instead of the native input.
 *
 * @internal
 */ const $a0746a27410bc168$var$CheckboxIcon = /*#__PURE__*/ (0, $5uXOq.memo)(({ isIndeterminate: isIndeterminate, isChecked: isChecked })=>{
    const icon = (0, $5uXOq.useMemo)(()=>$a0746a27410bc168$var$getIcon(isIndeterminate, isChecked), [
        isIndeterminate,
        isChecked
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dV6Te.default), {
        label: "",
        primaryColor: "var(--checkbox-background-color)",
        secondaryColor: "var(--checkbox-tick-color)",
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)("g", {
            fillRule: "evenodd",
            children: [
                // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
                (0, $VSDnB.fg)('platform-visual-refresh-icons') ? /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                    fill: "currentColor",
                    x: "5.5",
                    y: "5.5",
                    width: "13",
                    height: "13",
                    rx: "1.5"
                }) : /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                    fill: "currentColor",
                    x: "6",
                    y: "6",
                    width: "12",
                    height: "12",
                    rx: "2"
                }),
                icon
            ]
        })
    });
});
var $a0746a27410bc168$export$2e2bcd8739ae039 = $a0746a27410bc168$var$CheckboxIcon;

});

parcelRegister("7xteU", function(module, exports) {

$parcel$export(module.exports, "default", () => $7b368d644c230660$export$2e2bcd8739ae039);
/* label.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $7b368d644c230660$var$baseStyles = null;
const $7b368d644c230660$var$textLabelLayoutStyles = null;
const $7b368d644c230660$var$disabledStyles = null;
const $7b368d644c230660$var$labelStyles = null;
function $7b368d644c230660$export$2e2bcd8739ae039({ children: children, isDisabled: isDisabled, testId: testId, label: label, id: id, xcss: xcss }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)("label", {
        className: (0, $bwpsq.default)([
            "_11c82smr _1e0c11p5 _1ejihkll _umai184x _syazj3m3 _80om73ad",
            label && "_zulp1nu5 _yv0ey09t",
            isDisabled && "_syaz1tvo _80om13gf",
            "_h5e3mag2 _1nzs11d3 _1eszzyvw _yp0jhh5a _ay2w1y1w _d51u10ko _phft1fmg _1g1funzk _l6wkzyvw _1dikhh5a _1sfg1q3k _fpdj1y1w _1yjc194a _oaj11fmg _1j3h1q3k _eawb1dzn _1rda1qbb _18q015t7 _13hr3acm",
            xcss
        ]),
        "data-testid": testId,
        "data-disabled": isDisabled || undefined,
        id: id,
        children: children
    });
}

});

parcelRegister("hsLv2", function(module, exports) {

$parcel$export(module.exports, "default", () => $ce636d67b4ff1120$export$2e2bcd8739ae039);
/* label-text.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $ce636d67b4ff1120$var$labelTextStyles = null;
function $ce636d67b4ff1120$export$2e2bcd8739ae039({ children: children }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        className: (0, $bwpsq.default)([
            "_nd5l11ig _1wpz1h6o"
        ]),
        children: children
    });
}

});

parcelRegister("e62YQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $d2156c28a3894cac$export$2e2bcd8739ae039);
/* required-indicator.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $d2156c28a3894cac$var$requiredIndicatorStyles = null;
function $d2156c28a3894cac$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        "aria-hidden": true,
        className: (0, $bwpsq.default)([
            "_syaz1gtz _bozgv77o"
        ]),
        children: "*"
    });
}

});


parcelRegister("jDrwg", function(module, exports) {

$parcel$export(module.exports, "default", () => $049f084810e3e7c4$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $lFKmC = parcelRequire("lFKmC");
function $049f084810e3e7c4$export$2e2bcd8739ae039(callback, delay, options) {
    const optionsRef = (0, $5uXOq.useRef)(options);
    // @ts-expect-error - TS7019 - Rest parameter 'args' implicitly has an 'any[]' type.
    const callbackRef = (0, $5uXOq.useRef)((...args)=>{
        callback(...args);
    });
    callbackRef.current = callback;
    const debouncedCallBack = (0, $5uXOq.useMemo)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    ()=>(0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))((...args)=>callbackRef.current(...args), delay, optionsRef.current), [
        delay
    ]);
    (0, $5uXOq.useEffect)(()=>debouncedCallBack.cancel, [
        debouncedCallBack
    ]);
    return [
        debouncedCallBack,
        debouncedCallBack.cancel
    ];
}

});

parcelRegister("9InRy", function(module, exports) {

$parcel$export(module.exports, "useShowErrorFlag", () => $688f1fcbf2ebe50b$export$7b656ca20272d6d6);

var $5uXOq = parcelRequire("5uXOq");

var $7HGHK = parcelRequire("7HGHK");
var $pa9q9 = parcelRequire("pa9q9");


var $2N0ub = parcelRequire("2N0ub");
const $688f1fcbf2ebe50b$export$7b656ca20272d6d6 = ()=>{
    const { showFlag: showFlag } = (0, $pa9q9.useFlagService)();
    const showErrorFlag = (0, $5uXOq.useCallback)((errorMessageDescription)=>showFlag({
            key: (0, $7HGHK.toFlagId)((0, $de5881e58df3bf21$export$f5e4c120ac01b615)),
            testId: 'personal-settings-notifications-config-table.common.error-flag',
            type: 'error',
            title: (0, $2N0ub.default).errorFlagTitleNonFinal,
            description: errorMessageDescription || (0, $2N0ub.default).errorFlagDescriptionNonFinal,
            isAutoDismiss: true,
            messageId: 'personal-settings-error-flag.ui.show-flag.error',
            messageType: 'transactional'
        }), [
        showFlag
    ]);
    return {
        showErrorFlag: showErrorFlag
    };
};

});
const $de5881e58df3bf21$export$f5e4c120ac01b615 = 'NOTIFICATIONS_CONFIG_ERROR_FLAG';

parcelRegister("2N0ub", function(module, exports) {

$parcel$export(module.exports, "default", () => $47987370824ce994$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $47987370824ce994$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    errorFlagTitleNonFinal: {
        "id": "personal-settings-error-flag.error-flag-title-non-final",
        "defaultMessage": "Something went wrong"
    },
    errorFlagDescriptionNonFinal: {
        "id": "personal-settings-error-flag.error-flag-description-non-final",
        "defaultMessage": "There was an issue updating your notifications preference, we're working on fixing it, please try again later."
    }
});

});


parcelRegister("eCMal", function(module, exports) {

$parcel$export(module.exports, "default", () => $62fd151ab5b6b1fc$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $62fd151ab5b6b1fc$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    digestsNotificationsPageTitle: {
        "id": "personal-settings-digests-notifications.digests-notifications-page-title",
        "defaultMessage": "Digest notifications"
    },
    digestsNotificationsExplanation: {
        "id": "personal-settings-digests-notifications.digests-notifications-explanation",
        "defaultMessage": "Digests are a way to see important notifications about your projects."
    },
    digestsNotificationsAbout: {
        "id": "personal-settings-digests-notifications.digests-notifications-about",
        "defaultMessage": "About digests"
    },
    digestsNotificationsControl: {
        "id": "personal-settings-digests-notifications.digests-notifications-control",
        "defaultMessage": "Control your digest notifications:"
    },
    digestsNotificationsReceiveNotifications: {
        "id": "personal-settings-digests-notifications.digests-notifications-receive-notifications",
        "defaultMessage": "Receive notifications via:"
    },
    digestsNotificationsReceiveNotificationsEmail: {
        "id": "personal-settings-digests-notifications.digests-notifications-receive-notifications-email",
        "defaultMessage": "Email"
    },
    digestsNotificationsReceiveNotificationsInProduct: {
        "id": "personal-settings-digests-notifications.digests-notifications-receive-notifications-in-product",
        "defaultMessage": "In product"
    },
    digestsNotificationsReceiveNotificationsSlack: {
        "id": "personal-settings-digests-notifications.digests-notifications-receive-notifications-slack",
        "defaultMessage": "Slack"
    },
    digestsNotificationsDueOrOverdueIssues: {
        "id": "personal-settings-digests-notifications.digests-notifications-due-or-overdue-issues",
        "defaultMessage": "Due or overdue issues"
    },
    digestsNotificationsDueOrOverdueWork: {
        "id": "personal-settings-digests-notifications.digests-notifications-due-or-overdue-work",
        "defaultMessage": "Due or overdue work items"
    },
    digestsNotificationsProjectInviter: {
        "id": "personal-settings-digests-notifications.digests-notifications-project-inviter",
        "defaultMessage": "You've invited a new user and they don't have assigned work items"
    }
});

});


parcelRegister("6xkfG", function(module, exports) {

$parcel$export(module.exports, "CombinedPrefDueDateNotification", () => $b10fa3f522365616$export$dabbdad7ba6e2ff1);

var $4CnOM = parcelRequire("4CnOM");

var $6z3SW = parcelRequire("6z3SW");

var $8CRLz = parcelRequire("8CRLz");

var $5IpkU = parcelRequire("5IpkU");

var $kWpkw = parcelRequire("kWpkw");

var $du9s6 = parcelRequire("du9s6");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $dTlW6 = parcelRequire("dTlW6");

var $2x3Cb = parcelRequire("2x3Cb");

var $dC5iT = parcelRequire("dC5iT");
var $f5TWP = parcelRequire("f5TWP");
var $8CUq3 = parcelRequire("8CUq3");

var $2NMNM = parcelRequire("2NMNM");

var $jDrwg = parcelRequire("jDrwg");

var $koVbs = parcelRequire("koVbs");

var $koeKL = parcelRequire("koeKL");

var $9InRy = parcelRequire("9InRy");

var $jcw0u = parcelRequire("jcw0u");

var $8zOmE = parcelRequire("8zOmE");

var $4R6GH = parcelRequire("4R6GH");

var $6s1PB = parcelRequire("6s1PB");

var $eCMal = parcelRequire("eCMal");
const $b10fa3f522365616$export$dabbdad7ba6e2ff1 = ({ onToggleChange: onToggleChange, emailPreferenceFragment: emailPreferenceFragment, inProductPreferenceFragment: inProductPreferenceFragment, slackPreferenceFragment: slackPreferenceFragment })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const cloudId = (0, $koeKL.useCloudId)();
    const { showErrorFlag: showErrorFlag } = (0, $9InRy.useShowErrorFlag)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [slackExpConfig] = (0, $6s1PB.UNSAFE_noExposureExp)('due-date-notifications-slack-integration');
    const emailData = (0, $8Uumt.useFragment)((0, $du9s6.default), emailPreferenceFragment);
    const inProductData = (0, $8Uumt.useFragment)((0, $kWpkw.default), inProductPreferenceFragment);
    const slackData = (0, $8Uumt.useFragment)((0, $5IpkU.default), slackPreferenceFragment);
    const [commitEmail] = (0, $8Uumt.useMutation)((0, $8CRLz.default));
    const [commitInProduct] = (0, $8Uumt.useMutation)((0, $6z3SW.default));
    const [commitSlack] = (0, $8Uumt.useMutation)((0, $4CnOM.default));
    const [debouncedHandleToggleChange] = (0, $jDrwg.default)((e, analyticsEventUI)=>{
        const newValue = e.target.checked;
        onToggleChange(newValue);
        (0, $8zOmE.fireUIAnalytics)(analyticsEventUI, 'toggleDueDateNotificationSwitch', {
            isToggleOn: newValue
        });
        const promises = [];
        // Commit all three mutations in parallel as we can't make a single mutation for all notification channels
        promises.push(new Promise((resolve, reject)=>{
            commitEmail({
                variables: {
                    cloudId: cloudId,
                    isEnabled: newValue
                },
                optimisticResponse: {
                    jira: {
                        updateGlobalNotificationPreferences: {
                            success: true,
                            errors: [],
                            preferences: {
                                dailyDueDateNotification: {
                                    id: emailData.dailyDueDateNotification?.id ?? '',
                                    emailChannel: {
                                        isEnabled: newValue
                                    }
                                }
                            }
                        }
                    }
                },
                onError: (error)=>{
                    showErrorFlag();
                    (0, $jcw0u.default)({
                        meta: {
                            id: 'mutateOverdueNotifEmailPreference',
                            packageName: 'jiraPersonalSettingsNotificationsDigests',
                            teamName: 'frontier'
                        },
                        error: error,
                        sendToPrivacyUnsafeSplunk: true
                    });
                    reject(error);
                },
                onCompleted: (response)=>{
                    const errors = response?.jira?.updateGlobalNotificationPreferences?.errors;
                    if (errors && errors.length > 0) {
                        showErrorFlag();
                        errors.forEach((error)=>{
                            (0, $jcw0u.default)({
                                meta: {
                                    id: 'mutateOverdueNotifEmailPreferenceCompletedError',
                                    packageName: 'jiraPersonalSettingsNotificationsDigests',
                                    teamName: 'frontier'
                                },
                                error: new Error(error?.message || 'Unknown Error'),
                                sendToPrivacyUnsafeSplunk: true
                            });
                        });
                    } else (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'mutateOverdueNotifEmailPreference success');
                    resolve(response);
                }
            });
        }), new Promise((resolve, reject)=>{
            commitInProduct({
                variables: {
                    cloudId: cloudId,
                    isEnabled: newValue
                },
                optimisticResponse: {
                    jira: {
                        updateGlobalNotificationPreferences: {
                            success: true,
                            errors: [],
                            preferences: {
                                dailyDueDateNotification: {
                                    id: inProductData.dailyDueDateNotification?.id ?? '',
                                    inProductChannel: {
                                        isEnabled: newValue
                                    }
                                }
                            }
                        }
                    }
                },
                onError: (error)=>{
                    showErrorFlag();
                    (0, $jcw0u.default)({
                        meta: {
                            id: 'mutateOverdueNotifInProductPreference',
                            packageName: 'jiraPersonalSettingsNotificationsDigests',
                            teamName: 'jira-notifications-platform'
                        },
                        error: error,
                        sendToPrivacyUnsafeSplunk: true
                    });
                    reject(error);
                },
                onCompleted: (response)=>{
                    const errors = response?.jira?.updateGlobalNotificationPreferences?.errors;
                    if (errors && errors.length > 0) {
                        showErrorFlag();
                        errors.forEach((error)=>{
                            (0, $jcw0u.default)({
                                meta: {
                                    id: 'mutateOverdueNotifInProductPreferenceCompletedError',
                                    packageName: 'jiraPersonalSettingsNotificationsDigests',
                                    teamName: 'frontier'
                                },
                                error: new Error(error?.message || 'Unknown Error'),
                                sendToPrivacyUnsafeSplunk: true
                            });
                        });
                    } else (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'mutateOverdueNotifInProductPreference success');
                    resolve(response);
                }
            });
        }));
        // Only include slack mutation if experiment is enabled
        if (slackExpConfig.get('isEnabled', 'False') === 'True') promises.push(new Promise((resolve, reject)=>{
            commitSlack({
                variables: {
                    cloudId: cloudId,
                    isEnabled: newValue
                },
                optimisticResponse: {
                    jira: {
                        updateGlobalNotificationPreferences: {
                            success: true,
                            errors: [],
                            preferences: {
                                dailyDueDateNotification: {
                                    id: slackData.dailyDueDateNotification?.id ?? '',
                                    slackChannel: {
                                        isEnabled: newValue
                                    }
                                }
                            }
                        }
                    }
                },
                onError: (error)=>{
                    showErrorFlag();
                    (0, $jcw0u.default)({
                        meta: {
                            id: 'mutateOverdueNotifSlackPreference',
                            packageName: 'jiraPersonalSettingsNotificationsDigests',
                            teamName: 'jira-notifications-platform'
                        },
                        error: error,
                        sendToPrivacyUnsafeSplunk: true
                    });
                    reject(error);
                },
                onCompleted: (response)=>{
                    const errors = response?.jira?.updateGlobalNotificationPreferences?.errors;
                    if (errors && errors.length > 0) {
                        showErrorFlag();
                        errors.forEach((error)=>{
                            (0, $jcw0u.default)({
                                meta: {
                                    id: 'mutateOverdueNotifSlackPreferenceCompletedError',
                                    packageName: 'jiraPersonalSettingsNotificationsDigests',
                                    teamName: 'jira-notifications-platform'
                                },
                                error: new Error(error?.message || 'Unknown Error'),
                                sendToPrivacyUnsafeSplunk: true
                            });
                        });
                    } else (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'mutateOverdueNotifSlackPreference success');
                    resolve(response);
                }
            });
        }));
        Promise.all(promises).catch((error)=>{
            (0, $jcw0u.default)({
                meta: {
                    id: 'mutateOverdueNotifInProductPreferenceCompletedError',
                    packageName: 'jiraPersonalSettingsNotificationsDigests',
                    teamName: 'jira-notifications-platform'
                },
                error: new Error(error?.message || 'Unknown Error'),
                sendToPrivacyUnsafeSplunk: true
            });
        });
    }, 300, {
        leading: true,
        trailing: true
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: [
            $b10fa3f522365616$var$headerWrapperStyles,
            $b10fa3f522365616$var$enabledHeaderWrapperStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        spread: "space-between",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2x3Cb.Label), {
        htmlFor: "due-date-notifs-enabled"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        alignBlock: "center",
        xcss: $b10fa3f522365616$var$labelHolderStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        testId: "personal-settings-digest-notifications.common.ui.combined-pref-due-date-notif.toggle",
        xcss: $b10fa3f522365616$var$headerLabelStyles,
        alignBlock: "center"
    }, formatMessage((0, $4R6GH.fg)('digests-toggle-terminology-refresh') ? (0, $eCMal.default).digestsNotificationsDueOrOverdueWork : (0, $eCMal.default).digestsNotificationsDueOrOverdueIssues)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dTlW6.default), {
        id: "due-date-notifs-enabled",
        isChecked: !!inProductData.dailyDueDateNotification?.inProductChannel?.isEnabled || !!emailData.dailyDueDateNotification?.emailChannel?.isEnabled || slackExpConfig.get('isEnabled', 'False') === 'True' && !!slackData.dailyDueDateNotification?.slackChannel?.isEnabled,
        onChange: (e, analyticsEventUI)=>debouncedHandleToggleChange(e, analyticsEventUI)
    })));
};
const $b10fa3f522365616$var$headerLabelStyles = (0, $8CUq3.xcss)({
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    fontWeight: "var(--ds-font-weight-medium, 500)",
    color: 'color.text'
});
const $b10fa3f522365616$var$headerWrapperStyles = (0, $8CUq3.xcss)({
    borderWidth: 'border.width',
    borderStyle: 'solid',
    borderColor: 'color.border',
    borderRadius: 'border.radius.100',
    paddingRight: 'space.150',
    paddingLeft: 'space.200',
    paddingTop: 'space.100',
    paddingBottom: 'space.100'
});
const $b10fa3f522365616$var$enabledHeaderWrapperStyles = (0, $8CUq3.xcss)({
    borderBottomLeftRadius: '0px',
    borderBottomRightRadius: '0px',
    backgroundColor: 'elevation.surface.sunken'
});
const $b10fa3f522365616$var$labelHolderStyles = (0, $8CUq3.xcss)({
    marginTop: 'space.050',
    gap: 'space.100'
});

});
parcelRegister("4CnOM", function(module, exports) {

$parcel$export(module.exports, "default", () => $b23210891b78d4af$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f3d452b3b96db5446ce45e7db94299a1>>
 * @relayHash 6f82bc10e075c9e5112b6fd34ec255cf
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9d24ef38c8cbe03727b3410a36f95000071dbb165369135b8c8290458d9d4ea9
const $b23210891b78d4af$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isEnabled"
        }
    ], v1 = [
        {
            "concreteType": "JiraMutation",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "cloudId",
                            "variableName": "cloudId"
                        },
                        {
                            "fields": [
                                {
                                    "items": [
                                        {
                                            "fields": [
                                                {
                                                    "kind": "Literal",
                                                    "name": "channel",
                                                    "value": "SLACK"
                                                },
                                                {
                                                    "kind": "Variable",
                                                    "name": "isEnabled",
                                                    "variableName": "isEnabled"
                                                },
                                                {
                                                    "kind": "Literal",
                                                    "name": "type",
                                                    "value": "DAILY_DUE_DATE_NOTIFICATION"
                                                }
                                            ],
                                            "kind": "ObjectValue",
                                            "name": "preferences.0"
                                        }
                                    ],
                                    "kind": "ListValue",
                                    "name": "preferences"
                                }
                            ],
                            "kind": "ObjectValue",
                            "name": "input"
                        }
                    ],
                    "concreteType": "JiraUpdateGlobalPreferencesPayload",
                    "kind": "LinkedField",
                    "name": "updateGlobalNotificationPreferences",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "success"
                        },
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "message"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "combinedPrefDueDateNotifSlackPref_personalSettingsDigestNotificationsMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "combinedPrefDueDateNotifSlackPref_personalSettingsDigestNotificationsMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "9d24ef38c8cbe03727b3410a36f95000071dbb165369135b8c8290458d9d4ea9",
            "metadata": {},
            "name": "combinedPrefDueDateNotifSlackPref_personalSettingsDigestNotificationsMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$b23210891b78d4af$var$node.hash = "bd1e431b372bf7c0fda8fafe9e62362d";
var $b23210891b78d4af$export$2e2bcd8739ae039 = $b23210891b78d4af$var$node;

});

parcelRegister("6z3SW", function(module, exports) {

$parcel$export(module.exports, "default", () => $3905ab8f2722d93c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3bf77f1ddcd6b2c25f9f17b94e8ac822>>
 * @relayHash 4dbd001891d8db1c45335b7f7eb92952
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b38034ebb4c85bafeda6a96c971097c4dbedec9122f7a9de370c171a04d303e6
const $3905ab8f2722d93c$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isEnabled"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "fields": [
                {
                    "items": [
                        {
                            "fields": [
                                {
                                    "kind": "Literal",
                                    "name": "channel",
                                    "value": "IN_PRODUCT"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "isEnabled",
                                    "variableName": "isEnabled"
                                },
                                {
                                    "kind": "Literal",
                                    "name": "type",
                                    "value": "DAILY_DUE_DATE_NOTIFICATION"
                                }
                            ],
                            "kind": "ObjectValue",
                            "name": "preferences.0"
                        }
                    ],
                    "kind": "ListValue",
                    "name": "preferences"
                }
            ],
            "kind": "ObjectValue",
            "name": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "combinedPrefDueDateNotifInProductPref_personalSettingsDigestNotificationsMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraUpdateGlobalPreferencesPayload",
                            "kind": "LinkedField",
                            "name": "updateGlobalNotificationPreferences",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraNotificationPreferences",
                                    "kind": "LinkedField",
                                    "name": "preferences",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "combinedPrefDueDateNotif_personalSettingsDigestNotifications_CombinedPrefDueDateNotification_inProductPreferenceFragment"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "combinedPrefDueDateNotifInProductPref_personalSettingsDigestNotificationsMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraUpdateGlobalPreferencesPayload",
                            "kind": "LinkedField",
                            "name": "updateGlobalNotificationPreferences",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraNotificationPreferences",
                                    "kind": "LinkedField",
                                    "name": "preferences",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraNotificationPreference",
                                            "kind": "LinkedField",
                                            "name": "dailyDueDateNotification",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "id"
                                                },
                                                {
                                                    "concreteType": "JiraNotificationChannel",
                                                    "kind": "LinkedField",
                                                    "name": "inProductChannel",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "isEnabled"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "b38034ebb4c85bafeda6a96c971097c4dbedec9122f7a9de370c171a04d303e6",
            "metadata": {},
            "name": "combinedPrefDueDateNotifInProductPref_personalSettingsDigestNotificationsMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$3905ab8f2722d93c$var$node.hash = "bea6d083054c507b47bf5d06cf5fde4c";
var $3905ab8f2722d93c$export$2e2bcd8739ae039 = $3905ab8f2722d93c$var$node;

});

parcelRegister("8CRLz", function(module, exports) {

$parcel$export(module.exports, "default", () => $31d4e0d5e3c9cd78$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<aeae1921e0a7595ad3a6688c3056e554>>
 * @relayHash 5fffabf4694ee37ff8be7f447d5a2f65
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b445406000f0a108f0130bb28e8b8f37b6c4d6f568e0e700540ef084b798cde2
const $31d4e0d5e3c9cd78$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isEnabled"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "fields": [
                {
                    "items": [
                        {
                            "fields": [
                                {
                                    "kind": "Literal",
                                    "name": "channel",
                                    "value": "EMAIL"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "isEnabled",
                                    "variableName": "isEnabled"
                                },
                                {
                                    "kind": "Literal",
                                    "name": "type",
                                    "value": "DAILY_DUE_DATE_NOTIFICATION"
                                }
                            ],
                            "kind": "ObjectValue",
                            "name": "preferences.0"
                        }
                    ],
                    "kind": "ListValue",
                    "name": "preferences"
                }
            ],
            "kind": "ObjectValue",
            "name": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "combinedPrefDueDateNotifEmailPref_personalSettingsDigestNotificationsMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraUpdateGlobalPreferencesPayload",
                            "kind": "LinkedField",
                            "name": "updateGlobalNotificationPreferences",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraNotificationPreferences",
                                    "kind": "LinkedField",
                                    "name": "preferences",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "combinedPrefDueDateNotif_personalSettingsDigestNotifications_CombinedPrefDueDateNotification_emailPreferenceFragment"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "combinedPrefDueDateNotifEmailPref_personalSettingsDigestNotificationsMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraUpdateGlobalPreferencesPayload",
                            "kind": "LinkedField",
                            "name": "updateGlobalNotificationPreferences",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraNotificationPreferences",
                                    "kind": "LinkedField",
                                    "name": "preferences",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraNotificationPreference",
                                            "kind": "LinkedField",
                                            "name": "dailyDueDateNotification",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "id"
                                                },
                                                {
                                                    "concreteType": "JiraNotificationChannel",
                                                    "kind": "LinkedField",
                                                    "name": "emailChannel",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "isEnabled"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "b445406000f0a108f0130bb28e8b8f37b6c4d6f568e0e700540ef084b798cde2",
            "metadata": {},
            "name": "combinedPrefDueDateNotifEmailPref_personalSettingsDigestNotificationsMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$31d4e0d5e3c9cd78$var$node.hash = "4dadcb91b8cbb3fe46050d8a4371c87f";
var $31d4e0d5e3c9cd78$export$2e2bcd8739ae039 = $31d4e0d5e3c9cd78$var$node;

});

parcelRegister("5IpkU", function(module, exports) {

$parcel$export(module.exports, "default", () => $d53fceff1b710432$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<08cee26c5d549b39077ab3695468e873>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $d53fceff1b710432$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "combinedPrefDueDateNotif_personalSettingsDigestNotifications_CombinedPrefDueDateNotification_slackPreferenceFragment",
    "selections": [
        {
            "concreteType": "JiraNotificationPreference",
            "kind": "LinkedField",
            "name": "dailyDueDateNotification",
            "plural": false,
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "kind": "ScalarField",
                        "name": "id"
                    },
                    "action": "THROW",
                    "path": "dailyDueDateNotification.id"
                },
                {
                    "concreteType": "JiraNotificationChannel",
                    "kind": "LinkedField",
                    "name": "slackChannel",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isEnabled"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraNotificationPreferences"
};
$d53fceff1b710432$var$node.hash = "19821646d7d2d9f665290751c3c840c1";
var $d53fceff1b710432$export$2e2bcd8739ae039 = $d53fceff1b710432$var$node;

});

parcelRegister("kWpkw", function(module, exports) {

$parcel$export(module.exports, "default", () => $ca700c6f6845dc63$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d30e2a8833265948b2da62bea9f44148>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $ca700c6f6845dc63$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "combinedPrefDueDateNotif_personalSettingsDigestNotifications_CombinedPrefDueDateNotification_inProductPreferenceFragment",
    "selections": [
        {
            "concreteType": "JiraNotificationPreference",
            "kind": "LinkedField",
            "name": "dailyDueDateNotification",
            "plural": false,
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "kind": "ScalarField",
                        "name": "id"
                    },
                    "action": "THROW",
                    "path": "dailyDueDateNotification.id"
                },
                {
                    "concreteType": "JiraNotificationChannel",
                    "kind": "LinkedField",
                    "name": "inProductChannel",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isEnabled"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraNotificationPreferences"
};
$ca700c6f6845dc63$var$node.hash = "ff67dbedfb6689d832f3f9ea10816115";
var $ca700c6f6845dc63$export$2e2bcd8739ae039 = $ca700c6f6845dc63$var$node;

});

parcelRegister("du9s6", function(module, exports) {

$parcel$export(module.exports, "default", () => $12d971f688461570$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ae869a724ab5f6ce7680adf4dfbcd4ea>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $12d971f688461570$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "combinedPrefDueDateNotif_personalSettingsDigestNotifications_CombinedPrefDueDateNotification_emailPreferenceFragment",
    "selections": [
        {
            "concreteType": "JiraNotificationPreference",
            "kind": "LinkedField",
            "name": "dailyDueDateNotification",
            "plural": false,
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "kind": "ScalarField",
                        "name": "id"
                    },
                    "action": "THROW",
                    "path": "dailyDueDateNotification.id"
                },
                {
                    "concreteType": "JiraNotificationChannel",
                    "kind": "LinkedField",
                    "name": "emailChannel",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isEnabled"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraNotificationPreferences"
};
$12d971f688461570$var$node.hash = "c051c1e0e115281a1a88b043576a3766";
var $12d971f688461570$export$2e2bcd8739ae039 = $12d971f688461570$var$node;

});

parcelRegister("dTlW6", function(module, exports) {

$parcel$export(module.exports, "default", () => $3db77843cf29c460$export$2e2bcd8739ae039);
/* toggle.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $cBeZP = parcelRequire("cBeZP");

var $6QvkM = parcelRequire("6QvkM");

var $eGmKJ = parcelRequire("eGmKJ");

var $9KnKW = parcelRequire("9KnKW");

var $eJbwP = parcelRequire("eJbwP");

var $2jwCH = parcelRequire("2jwCH");

var $VSDnB = parcelRequire("VSDnB");

var $lahQ6 = parcelRequire("lahQ6");
const $3db77843cf29c460$var$basicStyles = null;
const $3db77843cf29c460$var$borderStyles = null;
const $3db77843cf29c460$var$iconStyles = null;
const $3db77843cf29c460$var$sizeStyles = {
    regular: "_2rkopxbi _4t3ipxbi _1bsbxy5q _kfgtutpp _1mp41crf _p9c41fbe",
    large: "_2rkov47k _4t3iv47k _1bsb1jfw _kfgtpxbi _1mp47vkz _p9c4w12q"
};
const $3db77843cf29c460$var$noop = (0, $eGmKJ.default);
const $3db77843cf29c460$var$analyticsAttributes = {
    componentName: 'toggle',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $3db77843cf29c460$var$iconSizeMap = {
    regular: 'small',
    large: 'medium'
}; /**
    * __Toggle__
    *
    * A toggle is used to view or switch between enabled or disabled states.
    *
    * - [Examples](https://atlassian.design/components/toggle/examples)
    * - [Code](https://atlassian.design/components/toggle/code)
    * - [Usage](https://atlassian.design/components/toggle/usage)
    */ 
const $3db77843cf29c460$var$Toggle = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const { defaultChecked: defaultChecked = false, isDisabled: isDisabled = false, onBlur: providedOnBlur = $3db77843cf29c460$var$noop, onChange: providedChange = $3db77843cf29c460$var$noop, onFocus: providedFocus = $3db77843cf29c460$var$noop, size: size = 'regular', name: name = '', value: value = '', isChecked: isChecked, analyticsContext: analyticsContext, id: id, testId: testId, label: label, descriptionId: descriptionId } = props;
    const isControlled = typeof isChecked === 'undefined';
    const [checked, setChecked] = (0, $5uXOq.useState)(defaultChecked);
    const [isKeyboardUsed, setIsKeyboardUsed] = (0, $5uXOq.useState)(true);
    const wrapperRef = (0, $5uXOq.useRef)(null);
    (0, $5uXOq.useEffect)(()=>{
        if (id && wrapperRef.current && wrapperRef.current.parentElement) {
            /*
      	DSP-21524 Handling the click on <label> that is linked via "for" attribute.
      	By default click on the label fires absolutely same onclick event as click on the input element.
      	To differentiate keyboard click from mouse we need this additional listener.
      */ const linkedLabel = wrapperRef.current.parentElement.querySelector(`label[for="${id}"]`);
            if (linkedLabel) {
                const unbind = (0, $cBeZP.bindAll)(linkedLabel, [
                    {
                        type: 'click',
                        listener: (event)=>{
                            setIsKeyboardUsed(false);
                            if (event?.detail > 1) /*
              DSP-21524 double or triple click on label initiating the text selection for label text and adds additional step to tab order.
              So here we set the isKeyboardUsed to true, to display focus ring on next Tab press
              */ setIsKeyboardUsed(true);
                        }
                    }
                ]);
                return unbind;
            }
        }
    }, [
        id,
        wrapperRef,
        isKeyboardUsed
    ]);
    const handleBlur = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: (event, analyticsEvent)=>{
            if (!isKeyboardUsed) setIsKeyboardUsed(true);
            providedOnBlur(event, analyticsEvent);
        },
        action: 'blur',
        analyticsData: analyticsContext,
        ...$3db77843cf29c460$var$analyticsAttributes
    });
    const handleFocus = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: providedFocus,
        action: 'focus',
        analyticsData: analyticsContext,
        ...$3db77843cf29c460$var$analyticsAttributes
    });
    const handleChange = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: (event, analyticsEvent)=>{
            if (isControlled) setChecked((checked)=>!checked);
            return providedChange(event, analyticsEvent);
        },
        action: 'change',
        analyticsData: analyticsContext,
        ...$3db77843cf29c460$var$analyticsAttributes
    });
    const onLabelKeyDown = (event)=>{
        if ([
            ' ',
            'Tab',
            'Space'
        ].includes(event.key)) setIsKeyboardUsed(true);
    };
    const shouldChecked = isControlled ? checked : isChecked;
    const controlProps = {
        'data-checked': shouldChecked ? shouldChecked : undefined,
        'data-disabled': isDisabled ? isDisabled : undefined,
        'data-size': size,
        'data-testid': testId ? testId : undefined,
        // DSP-21524 Because label gets focus ring via focus-within and focus-within also triggers by mouse click we have to manually control the ring appearance.
        onKeyDown: onLabelKeyDown,
        onMouseDown: ()=>{
            setIsKeyboardUsed(false);
        }
    };
    const legacyIconSize = $3db77843cf29c460$var$iconSizeMap[size];
    const labelId = (0, $9KnKW.useId)();
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("label", {
        ...controlProps,
        ref: wrapperRef,
        className: (0, $bwpsq.default)([
            "_v564kete _1h6d3acm _1dqonqa1 _189eyh40 _1e0c1o8l _vchh18uv _kqswh2mm _1y1m1ntv _bfhk76s1 _syaz5w2r _6rthv77o _1pfhv77o _12l2v77o _ahbqv77o _85i5v77o _1q51v77o _y4tiv77o _bozgv77o _1i2uidpf _1i3tidpf _se28idpf _3tunidpf _1423idpf _1hrtidpf _1bz2idpf _rqfvidpf _1yc0glyw _onsr1snc _1vgmagmp _1av610yn _1ulhidpf _rfx31q5u _pdykkete _1cs8stnw _1rus5w2r _1kt9b3bt _1fkr1y44 _z5wt1y44 _7dwzglyw _1bki1y1w _1flt1y1w _3xv21y1w _9471g4a2 _ucab5w2r _mqf815t7 _3dj215t7 _1dl915t7 _1div5w2r _1il8kb7n _y54d5w2r _irr353wy _d0altlke _19ja13gf _8muf13gf _1k1q13gf _1plud4ly _1uo853wy _178c1y1w _16rslghj _ogf41r31 _1rtbnqa1 _5gg9t94y",
            isKeyboardUsed && "_jyzf194a _1r4mnqa1 _1t9pyh40",
            size === 'large' && !(0, $VSDnB.fg)('platform-visual-refresh-icons') && "_1n82gktf _19vpgktf",
            $3db77843cf29c460$var$sizeStyles[size]
        ]),
        children: [
            label ? /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                id: labelId,
                hidden: true,
                children: label
            }) : null,
            /*#__PURE__*/ (0, $2OMIu.jsx)("input", {
                ref: ref,
                checked: shouldChecked,
                disabled: isDisabled,
                id: id,
                name: name,
                onBlur: handleBlur,
                onChange: handleChange,
                onFocus: handleFocus,
                type: "checkbox",
                value: value,
                "data-testid": testId && `${testId}--input`,
                "aria-labelledby": label ? labelId : undefined,
                "aria-describedby": descriptionId
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lahQ6.default), {
                size: size,
                isHidden: !shouldChecked,
                position: "left",
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eJbwP))), {
                    label: "",
                    color: "currentColor",
                    LEGACY_size: legacyIconSize,
                    testId: testId && `${testId}--toggle-check-icon`,
                    size: "small"
                })
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lahQ6.default), {
                size: size,
                isHidden: shouldChecked,
                position: "right",
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2jwCH))), {
                    label: "",
                    color: "currentColor",
                    LEGACY_size: legacyIconSize,
                    testId: testId && `${testId}--toggle-cross-icon`,
                    size: "small"
                })
            })
        ]
    });
}));
$3db77843cf29c460$var$Toggle.displayName = 'Toggle';
var $3db77843cf29c460$export$2e2bcd8739ae039 = $3db77843cf29c460$var$Toggle;

});
parcelRegister("eJbwP", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::666ec8073f4584891951ab85e48975eb>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ab8e35fd94105dfe$var$_react = $ab8e35fd94105dfe$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $ab8e35fd94105dfe$var$_checkMark = $ab8e35fd94105dfe$var$_interopRequireDefault((parcelRequire("bjo8S")));

var $ab8e35fd94105dfe$var$_done = $ab8e35fd94105dfe$var$_interopRequireDefault((parcelRequire("4DXCl")));
function $ab8e35fd94105dfe$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CheckMarkIcon.
 * This component is CheckMarkIcon, with `UNSAFE_fallbackIcon` set to "EditorDoneIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: table cells, checkboxes.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ab8e35fd94105dfe$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $ab8e35fd94105dfe$var$_react.default.createElement($ab8e35fd94105dfe$var$_checkMark.default, Object.assign({
        LEGACY_fallbackIcon: $ab8e35fd94105dfe$var$_done.default
    }, props));
$ab8e35fd94105dfe$var$CheckMarkIcon.Name = 'CheckMarkIconMigration';
var $ab8e35fd94105dfe$var$_default = module.exports.default = $ab8e35fd94105dfe$var$CheckMarkIcon;

});
parcelRegister("bjo8S", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a3e71f4112aeb66b16fbd284cc49bbc6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $83c43234bc70a485$var$_react = $83c43234bc70a485$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $83c43234bc70a485$var$_baseNew = $83c43234bc70a485$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $83c43234bc70a485$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CheckMark".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: table cells, checkboxes.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $83c43234bc70a485$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $83c43234bc70a485$var$_react.default.createElement($83c43234bc70a485$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m15.076 3.23-8.75 10.5a.75.75 0 0 1-1.159-.008l-4.25-5.25 1.166-.944 3.675 4.54 8.166-9.798z" clip-rule="evenodd"/>`
    }, props));
$83c43234bc70a485$var$CheckMarkIcon.displayName = 'CheckMarkIcon';
var $83c43234bc70a485$var$_default = module.exports.default = $83c43234bc70a485$var$CheckMarkIcon;

});

parcelRegister("4DXCl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $36190cbd288fec69$var$_react = $36190cbd288fec69$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $36190cbd288fec69$var$_checkMark = $36190cbd288fec69$var$_interopRequireDefault((parcelRequire("bjo8S")));
function $36190cbd288fec69$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $36190cbd288fec69$var$EditorDoneIcon = (props)=>/*#__PURE__*/ $36190cbd288fec69$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M7.356 10.942a.497.497 0 0 0-.713 0l-.7.701a.5.5 0 0 0-.003.71l3.706 3.707a.5.5 0 0 0 .705.003l7.712-7.712a.493.493 0 0 0-.006-.708l-.7-.7a.504.504 0 0 0-.714 0l-6.286 6.286a.506.506 0 0 1-.713 0z"/></svg>`
    }, props, {
        newIcon: $36190cbd288fec69$var$_checkMark.default
    }));
$36190cbd288fec69$var$EditorDoneIcon.displayName = 'EditorDoneIcon';
var $36190cbd288fec69$var$_default = module.exports.default = $36190cbd288fec69$var$EditorDoneIcon;

});


parcelRegister("lahQ6", function(module, exports) {

$parcel$export(module.exports, "default", () => $ca1cdaa1eb34599d$export$2e2bcd8739ae039);
/* icon-container.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $3JT92 = parcelRequire("3JT92");

var $VSDnB = parcelRequire("VSDnB");

var $MHKc7 = parcelRequire("MHKc7");
const $ca1cdaa1eb34599d$var$styles = {
    iconContainer: "_v5641hrg _1e0c116y _4cvr1h6o _1bah1h6o _kqswstnw _152tv77o",
    iconContainerRegular: "_1bsb7vkz _4t3i7vkz",
    iconContainerLarge: "_1bsbgktf _4t3igktf",
    hidden: "_tzy4idpf",
    left: "_1e021l7b",
    right: "_rjxp1l7b"
};
/**
 * __Icon container__
 *
 * Positions a toggle's check and close icons.
 */ const $ca1cdaa1eb34599d$var$IconContainer = ({ children: children, size: size, isHidden: isHidden, position: position })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        as: "span",
        xcss: (0, $3JT92.cx)($ca1cdaa1eb34599d$var$styles.iconContainer, isHidden && (0, $VSDnB.fg)('platform-visual-refresh-icons') && $ca1cdaa1eb34599d$var$styles.hidden, size === 'regular' && $ca1cdaa1eb34599d$var$styles.iconContainerRegular, size === 'large' && $ca1cdaa1eb34599d$var$styles.iconContainerLarge, position === 'left' && $ca1cdaa1eb34599d$var$styles.left, position === 'right' && $ca1cdaa1eb34599d$var$styles.right),
        children: children
    });
};
var $ca1cdaa1eb34599d$export$2e2bcd8739ae039 = $ca1cdaa1eb34599d$var$IconContainer;

});



parcelRegister("bYMxf", function(module, exports) {

$parcel$export(module.exports, "EmailPrefDueDateNotification", () => $d4ef1d7da967a56d$export$682840f71bf3aace);

var $ag0Kx = parcelRequire("ag0Kx");

var $3SstK = parcelRequire("3SstK");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $c0aEF = parcelRequire("c0aEF");

var $2x3Cb = parcelRequire("2x3Cb");

var $kkJfY = parcelRequire("kkJfY");

var $2NMNM = parcelRequire("2NMNM");

var $jDrwg = parcelRequire("jDrwg");

var $koVbs = parcelRequire("koVbs");

var $koeKL = parcelRequire("koeKL");

var $jcw0u = parcelRequire("jcw0u");

var $9InRy = parcelRequire("9InRy");

var $8zOmE = parcelRequire("8zOmE");

var $eCMal = parcelRequire("eCMal");
const $d4ef1d7da967a56d$export$682840f71bf3aace = ({ preferenceFragment: preferenceFragment })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const cloudId = (0, $koeKL.useCloudId)();
    const { showErrorFlag: showErrorFlag } = (0, $9InRy.useShowErrorFlag)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const data = (0, $8Uumt.useFragment)((0, $3SstK.default), preferenceFragment);
    const [commit] = (0, $8Uumt.useMutation)((0, $ag0Kx.default));
    const [debouncedHandleToggleChange] = (0, $jDrwg.default)((e, analyticsEventUI)=>{
        const newValue = e.currentTarget.checked;
        (0, $8zOmE.fireUIAnalytics)(analyticsEventUI, 'toggleDueDateNotificationSwitch', {
            isToggleOn: newValue
        });
        commit({
            variables: {
                cloudId: cloudId,
                isEnabled: newValue
            },
            optimisticResponse: {
                jira: {
                    updateGlobalNotificationPreferences: {
                        success: true,
                        errors: [],
                        preferences: {
                            dailyDueDateNotification: {
                                id: data.dailyDueDateNotification?.id ?? '',
                                emailChannel: {
                                    isEnabled: newValue
                                }
                            }
                        }
                    }
                }
            },
            onError: (error)=>{
                showErrorFlag();
                (0, $jcw0u.default)({
                    meta: {
                        id: 'mutateEmailPrefDueDateNotification',
                        packageName: 'jiraPersonalSettingsNotificationsDigests',
                        teamName: 'frontier'
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
            },
            onCompleted: (response)=>{
                const errors = response?.jira?.updateGlobalNotificationPreferences?.errors;
                if (errors && errors.length > 0) {
                    showErrorFlag();
                    errors.forEach((error)=>{
                        (0, $jcw0u.default)({
                            meta: {
                                id: 'mutateEmailPrefDueDateNotificationCompletedError',
                                packageName: 'jiraPersonalSettingsNotificationsDigests',
                                teamName: 'frontier'
                            },
                            error: new Error(error?.message || 'Unknown Error'),
                            sendToPrivacyUnsafeSplunk: true
                        });
                    });
                } else (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'mutateEmailPrefDueDateNotification success');
            }
        });
    }, 300, {
        leading: true,
        trailing: true
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2x3Cb.Label), {
        htmlFor: "notify-via-email-checkbox"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c0aEF.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kkJfY.default), {
        isChecked: !!data.dailyDueDateNotification?.emailChannel?.isEnabled,
        onChange: (e, analyticsEventUI)=>debouncedHandleToggleChange(e, analyticsEventUI),
        label: formatMessage((0, $eCMal.default).digestsNotificationsReceiveNotificationsEmail),
        testId: "personal-settings-digest-notifications.common.ui.email-pref-due-date-notif.notify-via-email-checkbox"
    })));
};

});
parcelRegister("ag0Kx", function(module, exports) {

$parcel$export(module.exports, "default", () => $5c81aabb32f2990e$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<fa5adf9e61fb876efe685911be9b2ecd>>
 * @relayHash 981b1d606e139f288d3b7792044bf665
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 005d48e734ba82c488f1fa623a99424bd8b5b93acd0ab3fa21fc3f3df01e854f
const $5c81aabb32f2990e$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isEnabled"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "fields": [
                {
                    "items": [
                        {
                            "fields": [
                                {
                                    "kind": "Literal",
                                    "name": "channel",
                                    "value": "EMAIL"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "isEnabled",
                                    "variableName": "isEnabled"
                                },
                                {
                                    "kind": "Literal",
                                    "name": "type",
                                    "value": "DAILY_DUE_DATE_NOTIFICATION"
                                }
                            ],
                            "kind": "ObjectValue",
                            "name": "preferences.0"
                        }
                    ],
                    "kind": "ListValue",
                    "name": "preferences"
                }
            ],
            "kind": "ObjectValue",
            "name": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "emailPrefDueDateNotificationMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraUpdateGlobalPreferencesPayload",
                            "kind": "LinkedField",
                            "name": "updateGlobalNotificationPreferences",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraNotificationPreferences",
                                    "kind": "LinkedField",
                                    "name": "preferences",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "emailPrefDueDateNotif_personalSettingsDigestNotifications_EmailPrefDueDateNotification"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "emailPrefDueDateNotificationMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraUpdateGlobalPreferencesPayload",
                            "kind": "LinkedField",
                            "name": "updateGlobalNotificationPreferences",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraNotificationPreferences",
                                    "kind": "LinkedField",
                                    "name": "preferences",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraNotificationPreference",
                                            "kind": "LinkedField",
                                            "name": "dailyDueDateNotification",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "id"
                                                },
                                                {
                                                    "concreteType": "JiraNotificationChannel",
                                                    "kind": "LinkedField",
                                                    "name": "emailChannel",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "isEnabled"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "005d48e734ba82c488f1fa623a99424bd8b5b93acd0ab3fa21fc3f3df01e854f",
            "metadata": {},
            "name": "emailPrefDueDateNotificationMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$5c81aabb32f2990e$var$node.hash = "fc34ab86bb341303055cf4073734b466";
var $5c81aabb32f2990e$export$2e2bcd8739ae039 = $5c81aabb32f2990e$var$node;

});

parcelRegister("3SstK", function(module, exports) {

$parcel$export(module.exports, "default", () => $39ac336d9b2e1173$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7048ddfdf66e93b89a94c22e5004ae40>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $39ac336d9b2e1173$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "emailPrefDueDateNotif_personalSettingsDigestNotifications_EmailPrefDueDateNotification",
    "selections": [
        {
            "concreteType": "JiraNotificationPreference",
            "kind": "LinkedField",
            "name": "dailyDueDateNotification",
            "plural": false,
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "kind": "ScalarField",
                        "name": "id"
                    },
                    "action": "THROW",
                    "path": "dailyDueDateNotification.id"
                },
                {
                    "concreteType": "JiraNotificationChannel",
                    "kind": "LinkedField",
                    "name": "emailChannel",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isEnabled"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraNotificationPreferences"
};
$39ac336d9b2e1173$var$node.hash = "e59131336e89f634651fdc32f297c471";
var $39ac336d9b2e1173$export$2e2bcd8739ae039 = $39ac336d9b2e1173$var$node;

});


parcelRegister("7hMoX", function(module, exports) {

$parcel$export(module.exports, "CombinedInviterNotification", () => $90674f8a610143e0$export$b7d6b43a0be78ba4);

var $gA5iI = parcelRequire("gA5iI");

var $kiAv8 = parcelRequire("kiAv8");

var $2gMmj = parcelRequire("2gMmj");

var $lgJdf = parcelRequire("lgJdf");

var $9isS6 = parcelRequire("9isS6");

var $gVJo7 = parcelRequire("gVJo7");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $dTlW6 = parcelRequire("dTlW6");

var $2x3Cb = parcelRequire("2x3Cb");

var $dC5iT = parcelRequire("dC5iT");
var $f5TWP = parcelRequire("f5TWP");
var $8CUq3 = parcelRequire("8CUq3");

var $2NMNM = parcelRequire("2NMNM");

var $jDrwg = parcelRequire("jDrwg");

var $koVbs = parcelRequire("koVbs");

var $koeKL = parcelRequire("koeKL");

var $9InRy = parcelRequire("9InRy");

var $jcw0u = parcelRequire("jcw0u");

var $8zOmE = parcelRequire("8zOmE");

var $eCMal = parcelRequire("eCMal");
const $90674f8a610143e0$export$b7d6b43a0be78ba4 = ({ onToggleChange: onToggleChange, emailFragment: emailFragment, inProductFragment: inProductFragment, slackFragment: slackFragment })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const cloudId = (0, $koeKL.useCloudId)();
    const { showErrorFlag: showErrorFlag } = (0, $9InRy.useShowErrorFlag)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const emailData = (0, $8Uumt.useFragment)((0, $gVJo7.default), emailFragment);
    const inProductData = (0, $8Uumt.useFragment)((0, $9isS6.default), inProductFragment);
    const slackData = (0, $8Uumt.useFragment)((0, $lgJdf.default), slackFragment);
    const [commitEmail] = (0, $8Uumt.useMutation)((0, $2gMmj.default));
    const [commitInProduct] = (0, $8Uumt.useMutation)((0, $kiAv8.default));
    const [commitSlack] = (0, $8Uumt.useMutation)((0, $gA5iI.default));
    const [debouncedHandleToggleChange] = (0, $jDrwg.default)((e, analyticsEventUI)=>{
        const newValue = e.target.checked;
        onToggleChange(newValue);
        (0, $8zOmE.fireUIAnalytics)(analyticsEventUI, 'toggleInviterNotificationSwitch', {
            isToggleOn: newValue,
            channel: 'combined'
        });
        // Commit all mutations in parallel as we can't make a single mutation for three notification channels
        Promise.all([
            new Promise((resolve, reject)=>{
                commitEmail({
                    variables: {
                        cloudId: cloudId,
                        isEnabled: newValue
                    },
                    optimisticResponse: {
                        jira: {
                            updateGlobalNotificationPreferences: {
                                success: true,
                                errors: [],
                                preferences: {
                                    projectInviterNotification: {
                                        id: emailData.projectInviterNotification?.id ?? '',
                                        emailChannel: {
                                            isEnabled: newValue
                                        }
                                    }
                                }
                            }
                        }
                    },
                    onError: (error)=>{
                        showErrorFlag();
                        (0, $jcw0u.default)({
                            meta: {
                                id: 'mutateInviterNotifEmailPreference',
                                packageName: 'jiraPersonalSettingsNotificationsDigests',
                                teamName: 'jira-warepil'
                            },
                            error: error,
                            sendToPrivacyUnsafeSplunk: true
                        });
                        reject(error);
                    },
                    onCompleted: (response)=>{
                        const errors = response?.jira?.updateGlobalNotificationPreferences?.errors;
                        if (errors && errors.length > 0) {
                            showErrorFlag();
                            errors.forEach((error)=>{
                                (0, $jcw0u.default)({
                                    meta: {
                                        id: 'mutateInviterNotifEmailPreferenceCompletedError',
                                        packageName: 'jiraPersonalSettingsNotificationsDigests',
                                        teamName: 'jira-warepil'
                                    },
                                    error: new Error(error?.message || 'Unknown Error'),
                                    sendToPrivacyUnsafeSplunk: true
                                });
                            });
                        } else (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'mutateInviterNotifEmailPreference success');
                        resolve(response);
                    }
                });
            }),
            new Promise((resolve, reject)=>{
                commitInProduct({
                    variables: {
                        cloudId: cloudId,
                        isEnabled: newValue
                    },
                    optimisticResponse: {
                        jira: {
                            updateGlobalNotificationPreferences: {
                                success: true,
                                errors: [],
                                preferences: {
                                    projectInviterNotification: {
                                        id: inProductData.projectInviterNotification?.id ?? '',
                                        inProductChannel: {
                                            isEnabled: newValue
                                        }
                                    }
                                }
                            }
                        }
                    },
                    onError: (error)=>{
                        showErrorFlag();
                        (0, $jcw0u.default)({
                            meta: {
                                id: 'mutateInviterNotifInProductPreference',
                                packageName: 'jiraPersonalSettingsNotificationsDigests',
                                teamName: 'jira-warepil'
                            },
                            error: error,
                            sendToPrivacyUnsafeSplunk: true
                        });
                        reject(error);
                    },
                    onCompleted: (response)=>{
                        const errors = response?.jira?.updateGlobalNotificationPreferences?.errors;
                        if (errors && errors.length > 0) {
                            showErrorFlag();
                            errors.forEach((error)=>{
                                (0, $jcw0u.default)({
                                    meta: {
                                        id: 'mutateInviterNotifInProductPreferenceCompletedError',
                                        packageName: 'jiraPersonalSettingsNotificationsDigests',
                                        teamName: 'jira-warepil'
                                    },
                                    error: new Error(error?.message || 'Unknown Error'),
                                    sendToPrivacyUnsafeSplunk: true
                                });
                            });
                        } else (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'mutateInviterNotifInProductPreference success');
                        resolve(response);
                    }
                });
            }),
            new Promise((resolve, reject)=>{
                commitSlack({
                    variables: {
                        cloudId: cloudId,
                        isEnabled: newValue
                    },
                    optimisticResponse: {
                        jira: {
                            updateGlobalNotificationPreferences: {
                                success: true,
                                errors: [],
                                preferences: {
                                    projectInviterNotification: {
                                        id: slackData.projectInviterNotification?.id ?? '',
                                        slackChannel: {
                                            isEnabled: newValue
                                        }
                                    }
                                }
                            }
                        }
                    },
                    onError: (error)=>{
                        showErrorFlag();
                        (0, $jcw0u.default)({
                            meta: {
                                id: 'mutateinviterNotifInProductPreference',
                                packageName: 'jiraPersonalSettingsNotificationsDigests',
                                teamName: 'jira-warepil'
                            },
                            error: error,
                            sendToPrivacyUnsafeSplunk: true
                        });
                        reject(error);
                    },
                    onCompleted: (response)=>{
                        const errors = response?.jira?.updateGlobalNotificationPreferences?.errors;
                        if (errors && errors.length > 0) {
                            showErrorFlag();
                            errors.forEach((error)=>{
                                (0, $jcw0u.default)({
                                    meta: {
                                        id: 'mutateinviterNotifInProductPreferenceCompletedError',
                                        packageName: 'jiraPersonalSettingsNotificationsDigests',
                                        teamName: 'jira-warepil'
                                    },
                                    error: new Error(error?.message || 'Unknown Error'),
                                    sendToPrivacyUnsafeSplunk: true
                                });
                            });
                        } else (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'mutateinviterNotifInProductPreference success');
                        resolve(response);
                    }
                });
            })
        ]).catch((error)=>{
            (0, $jcw0u.default)({
                meta: {
                    id: 'mutateInviterNotifInProductPreferenceCompletedError',
                    packageName: 'jiraPersonalSettingsNotificationsDigests',
                    teamName: 'jira-warepil'
                },
                error: new Error(error?.message || 'Unknown Error'),
                sendToPrivacyUnsafeSplunk: true
            });
        });
    }, 300, {
        leading: true,
        trailing: true
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: [
            $90674f8a610143e0$var$headerWrapperStyles,
            $90674f8a610143e0$var$enabledHeaderWrapperStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        spread: "space-between",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2x3Cb.Label), {
        htmlFor: "due-date-notifs-enabled"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        alignBlock: "center",
        xcss: $90674f8a610143e0$var$labelHolderStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        testId: "personal-settings-digest-notifications.common.ui.combined-inviter-notif.toggle",
        xcss: $90674f8a610143e0$var$headerLabelStyles,
        alignBlock: "center"
    }, formatMessage((0, $eCMal.default).digestsNotificationsProjectInviter)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dTlW6.default), {
        id: "inviter-notifs-enabled",
        isChecked: !!inProductData.projectInviterNotification?.inProductChannel?.isEnabled || !!emailData.projectInviterNotification?.emailChannel?.isEnabled || !!slackData.projectInviterNotification?.slackChannel?.isEnabled || false,
        onChange: (e, analyticsEventUI)=>debouncedHandleToggleChange(e, analyticsEventUI)
    })));
};
const $90674f8a610143e0$var$headerLabelStyles = (0, $8CUq3.xcss)({
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    fontWeight: "var(--ds-font-weight-medium, 500)",
    color: 'color.text'
});
const $90674f8a610143e0$var$headerWrapperStyles = (0, $8CUq3.xcss)({
    borderWidth: 'border.width',
    borderStyle: 'solid',
    borderColor: 'color.border',
    borderRadius: 'border.radius.100',
    paddingRight: 'space.150',
    paddingLeft: 'space.200',
    paddingTop: 'space.100',
    paddingBottom: 'space.100'
});
const $90674f8a610143e0$var$enabledHeaderWrapperStyles = (0, $8CUq3.xcss)({
    borderBottomLeftRadius: '0px',
    borderBottomRightRadius: '0px',
    backgroundColor: 'elevation.surface.sunken'
});
const $90674f8a610143e0$var$labelHolderStyles = (0, $8CUq3.xcss)({
    marginTop: 'space.050',
    gap: 'space.100'
});

});
parcelRegister("gA5iI", function(module, exports) {

$parcel$export(module.exports, "default", () => $2e309ec65be00c18$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2db5c558ecd68390c5397b9de3171efd>>
 * @relayHash c3c857618743a13eb8fe0696462cba60
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 28bb3c6f8f1e51f474d926b3e4f2f9f360538e242a7ab958906aef7b96993d1d
const $2e309ec65be00c18$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isEnabled"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "fields": [
                {
                    "items": [
                        {
                            "fields": [
                                {
                                    "kind": "Literal",
                                    "name": "channel",
                                    "value": "SLACK"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "isEnabled",
                                    "variableName": "isEnabled"
                                },
                                {
                                    "kind": "Literal",
                                    "name": "type",
                                    "value": "PROJECT_INVITER_NOTIFICATION"
                                }
                            ],
                            "kind": "ObjectValue",
                            "name": "preferences.0"
                        }
                    ],
                    "kind": "ListValue",
                    "name": "preferences"
                }
            ],
            "kind": "ObjectValue",
            "name": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "combinedInviterNotifSlackPref_personalSettingsDigestNotificationsMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraUpdateGlobalPreferencesPayload",
                            "kind": "LinkedField",
                            "name": "updateGlobalNotificationPreferences",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraNotificationPreferences",
                                    "kind": "LinkedField",
                                    "name": "preferences",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "combinedInviterNotif_personalSettingsDigestNotifications_CombinedInviterNotification_slackFragment"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "combinedInviterNotifSlackPref_personalSettingsDigestNotificationsMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraUpdateGlobalPreferencesPayload",
                            "kind": "LinkedField",
                            "name": "updateGlobalNotificationPreferences",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraNotificationPreferences",
                                    "kind": "LinkedField",
                                    "name": "preferences",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraNotificationPreference",
                                            "kind": "LinkedField",
                                            "name": "projectInviterNotification",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "id"
                                                },
                                                {
                                                    "concreteType": "JiraNotificationChannel",
                                                    "kind": "LinkedField",
                                                    "name": "slackChannel",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "isEnabled"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "28bb3c6f8f1e51f474d926b3e4f2f9f360538e242a7ab958906aef7b96993d1d",
            "metadata": {},
            "name": "combinedInviterNotifSlackPref_personalSettingsDigestNotificationsMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$2e309ec65be00c18$var$node.hash = "3f2e2a75758bb062e1be491291a15902";
var $2e309ec65be00c18$export$2e2bcd8739ae039 = $2e309ec65be00c18$var$node;

});

parcelRegister("kiAv8", function(module, exports) {

$parcel$export(module.exports, "default", () => $d8a66e58ea4c8409$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5c8d91104d073225b1cdc267c1ecf9c4>>
 * @relayHash a85de1684a1af81208cd946c49c7dfe7
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 93c41883323d519cd7e06b42c1a036be6cdb5791ac14b537e785367acfe5275d
const $d8a66e58ea4c8409$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isEnabled"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "fields": [
                {
                    "items": [
                        {
                            "fields": [
                                {
                                    "kind": "Literal",
                                    "name": "channel",
                                    "value": "IN_PRODUCT"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "isEnabled",
                                    "variableName": "isEnabled"
                                },
                                {
                                    "kind": "Literal",
                                    "name": "type",
                                    "value": "PROJECT_INVITER_NOTIFICATION"
                                }
                            ],
                            "kind": "ObjectValue",
                            "name": "preferences.0"
                        }
                    ],
                    "kind": "ListValue",
                    "name": "preferences"
                }
            ],
            "kind": "ObjectValue",
            "name": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "combinedInviterNotifInProductPref_personalSettingsDigestNotificationsMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraUpdateGlobalPreferencesPayload",
                            "kind": "LinkedField",
                            "name": "updateGlobalNotificationPreferences",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraNotificationPreferences",
                                    "kind": "LinkedField",
                                    "name": "preferences",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "combinedInviterNotif_personalSettingsDigestNotifications_CombinedInviterNotification_inProductFragment"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "combinedInviterNotifInProductPref_personalSettingsDigestNotificationsMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraUpdateGlobalPreferencesPayload",
                            "kind": "LinkedField",
                            "name": "updateGlobalNotificationPreferences",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraNotificationPreferences",
                                    "kind": "LinkedField",
                                    "name": "preferences",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraNotificationPreference",
                                            "kind": "LinkedField",
                                            "name": "projectInviterNotification",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "id"
                                                },
                                                {
                                                    "concreteType": "JiraNotificationChannel",
                                                    "kind": "LinkedField",
                                                    "name": "inProductChannel",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "isEnabled"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "93c41883323d519cd7e06b42c1a036be6cdb5791ac14b537e785367acfe5275d",
            "metadata": {},
            "name": "combinedInviterNotifInProductPref_personalSettingsDigestNotificationsMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$d8a66e58ea4c8409$var$node.hash = "72fcde0b2231cdf2eab67d73ce866b4a";
var $d8a66e58ea4c8409$export$2e2bcd8739ae039 = $d8a66e58ea4c8409$var$node;

});

parcelRegister("2gMmj", function(module, exports) {

$parcel$export(module.exports, "default", () => $4ed0e59a5e0bc2f1$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b442f629abb6fb40f922d4b6801bebec>>
 * @relayHash 92816726213c41de1a069befee3153ee
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7428a709a2570c74c8ba02e0d54d5053f5e7f19ae899ef7846799d0643ceb4f0
const $4ed0e59a5e0bc2f1$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isEnabled"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "fields": [
                {
                    "items": [
                        {
                            "fields": [
                                {
                                    "kind": "Literal",
                                    "name": "channel",
                                    "value": "EMAIL"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "isEnabled",
                                    "variableName": "isEnabled"
                                },
                                {
                                    "kind": "Literal",
                                    "name": "type",
                                    "value": "PROJECT_INVITER_NOTIFICATION"
                                }
                            ],
                            "kind": "ObjectValue",
                            "name": "preferences.0"
                        }
                    ],
                    "kind": "ListValue",
                    "name": "preferences"
                }
            ],
            "kind": "ObjectValue",
            "name": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "combinedInviterNotifEmailPref_personalSettingsDigestNotificationsMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraUpdateGlobalPreferencesPayload",
                            "kind": "LinkedField",
                            "name": "updateGlobalNotificationPreferences",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraNotificationPreferences",
                                    "kind": "LinkedField",
                                    "name": "preferences",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "combinedInviterNotif_personalSettingsDigestNotifications_CombinedInviterNotification_emailFragment"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "combinedInviterNotifEmailPref_personalSettingsDigestNotificationsMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraUpdateGlobalPreferencesPayload",
                            "kind": "LinkedField",
                            "name": "updateGlobalNotificationPreferences",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraNotificationPreferences",
                                    "kind": "LinkedField",
                                    "name": "preferences",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraNotificationPreference",
                                            "kind": "LinkedField",
                                            "name": "projectInviterNotification",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "id"
                                                },
                                                {
                                                    "concreteType": "JiraNotificationChannel",
                                                    "kind": "LinkedField",
                                                    "name": "emailChannel",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "isEnabled"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "7428a709a2570c74c8ba02e0d54d5053f5e7f19ae899ef7846799d0643ceb4f0",
            "metadata": {},
            "name": "combinedInviterNotifEmailPref_personalSettingsDigestNotificationsMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$4ed0e59a5e0bc2f1$var$node.hash = "2961cfa6918e3d6a5adccdc817e38172";
var $4ed0e59a5e0bc2f1$export$2e2bcd8739ae039 = $4ed0e59a5e0bc2f1$var$node;

});

parcelRegister("lgJdf", function(module, exports) {

$parcel$export(module.exports, "default", () => $3c7f554fef9ddc34$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<161f16c0ac2ff29bc9851be262076b2e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $3c7f554fef9ddc34$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "combinedInviterNotif_personalSettingsDigestNotifications_CombinedInviterNotification_slackFragment",
    "selections": [
        {
            "concreteType": "JiraNotificationPreference",
            "kind": "LinkedField",
            "name": "projectInviterNotification",
            "plural": false,
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "kind": "ScalarField",
                        "name": "id"
                    },
                    "action": "THROW",
                    "path": "projectInviterNotification.id"
                },
                {
                    "concreteType": "JiraNotificationChannel",
                    "kind": "LinkedField",
                    "name": "slackChannel",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isEnabled"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraNotificationPreferences"
};
$3c7f554fef9ddc34$var$node.hash = "efc9c904217730de71b3c48259238a37";
var $3c7f554fef9ddc34$export$2e2bcd8739ae039 = $3c7f554fef9ddc34$var$node;

});

parcelRegister("9isS6", function(module, exports) {

$parcel$export(module.exports, "default", () => $760bd6fb4a2decf5$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7ffed07f0f3795cd07c10787d4e78d01>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $760bd6fb4a2decf5$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "combinedInviterNotif_personalSettingsDigestNotifications_CombinedInviterNotification_inProductFragment",
    "selections": [
        {
            "concreteType": "JiraNotificationPreference",
            "kind": "LinkedField",
            "name": "projectInviterNotification",
            "plural": false,
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "kind": "ScalarField",
                        "name": "id"
                    },
                    "action": "THROW",
                    "path": "projectInviterNotification.id"
                },
                {
                    "concreteType": "JiraNotificationChannel",
                    "kind": "LinkedField",
                    "name": "inProductChannel",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isEnabled"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraNotificationPreferences"
};
$760bd6fb4a2decf5$var$node.hash = "d0f53f2e399bb8ace91f23d5e94a1399";
var $760bd6fb4a2decf5$export$2e2bcd8739ae039 = $760bd6fb4a2decf5$var$node;

});

parcelRegister("gVJo7", function(module, exports) {

$parcel$export(module.exports, "default", () => $ba0bb5562dfe6f69$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ffa88a9853fb95d1055a466cfe0661ba>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $ba0bb5562dfe6f69$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "combinedInviterNotif_personalSettingsDigestNotifications_CombinedInviterNotification_emailFragment",
    "selections": [
        {
            "concreteType": "JiraNotificationPreference",
            "kind": "LinkedField",
            "name": "projectInviterNotification",
            "plural": false,
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "kind": "ScalarField",
                        "name": "id"
                    },
                    "action": "THROW",
                    "path": "projectInviterNotification.id"
                },
                {
                    "concreteType": "JiraNotificationChannel",
                    "kind": "LinkedField",
                    "name": "emailChannel",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isEnabled"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraNotificationPreferences"
};
$ba0bb5562dfe6f69$var$node.hash = "e8f560deb537f4cf59917e90762abc7e";
var $ba0bb5562dfe6f69$export$2e2bcd8739ae039 = $ba0bb5562dfe6f69$var$node;

});


parcelRegister("9FgOX", function(module, exports) {

$parcel$export(module.exports, "EmailInviterNotification", () => $3dda3634305ceaa4$export$acc9e6bf1ae3c095);

var $jXdym = parcelRequire("jXdym");

var $hj92z = parcelRequire("hj92z");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $c0aEF = parcelRequire("c0aEF");

var $2x3Cb = parcelRequire("2x3Cb");

var $kkJfY = parcelRequire("kkJfY");

var $2NMNM = parcelRequire("2NMNM");

var $jDrwg = parcelRequire("jDrwg");

var $koVbs = parcelRequire("koVbs");

var $koeKL = parcelRequire("koeKL");

var $jcw0u = parcelRequire("jcw0u");

var $9InRy = parcelRequire("9InRy");

var $8zOmE = parcelRequire("8zOmE");

var $eCMal = parcelRequire("eCMal");
const $3dda3634305ceaa4$export$acc9e6bf1ae3c095 = ({ preferenceFragment: preferenceFragment })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const cloudId = (0, $koeKL.useCloudId)();
    const { showErrorFlag: showErrorFlag } = (0, $9InRy.useShowErrorFlag)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const data = (0, $8Uumt.useFragment)((0, $hj92z.default), preferenceFragment);
    const [commit] = (0, $8Uumt.useMutation)((0, $jXdym.default));
    const [debouncedHandleToggleChange] = (0, $jDrwg.default)((e, analyticsEventUI)=>{
        const newValue = e.currentTarget.checked;
        (0, $8zOmE.fireUIAnalytics)(analyticsEventUI, 'toggleInviterNotificationSwitch', {
            isToggleOn: newValue,
            channel: 'email'
        });
        commit({
            variables: {
                cloudId: cloudId,
                isEnabled: newValue
            },
            optimisticResponse: {
                jira: {
                    updateGlobalNotificationPreferences: {
                        success: true,
                        errors: [],
                        preferences: {
                            projectInviterNotification: {
                                id: data.projectInviterNotification?.id ?? '',
                                emailChannel: {
                                    isEnabled: newValue
                                }
                            }
                        }
                    }
                }
            },
            onError: (error)=>{
                showErrorFlag();
                (0, $jcw0u.default)({
                    meta: {
                        id: 'mutateEmailInviterNotification',
                        packageName: 'jiraPersonalSettingsNotificationsDigests',
                        teamName: 'jira-warepil'
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
            },
            onCompleted: (response)=>{
                const errors = response?.jira?.updateGlobalNotificationPreferences?.errors;
                if (errors && errors.length > 0) {
                    showErrorFlag();
                    errors.forEach((error)=>{
                        (0, $jcw0u.default)({
                            meta: {
                                id: 'mutateEmailInviterNotificationCompletedError',
                                packageName: 'jiraPersonalSettingsNotificationsDigests',
                                teamName: 'jira-warepil'
                            },
                            error: new Error(error?.message || 'Unknown Error'),
                            sendToPrivacyUnsafeSplunk: true
                        });
                    });
                } else (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'mutateEmailInviterNotification success');
            }
        });
    }, 300, {
        leading: true,
        trailing: true
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2x3Cb.Label), {
        htmlFor: "notify-via-email-checkbox"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c0aEF.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kkJfY.default), {
        isChecked: !!data.projectInviterNotification?.emailChannel?.isEnabled,
        onChange: (e, analyticsEventUI)=>debouncedHandleToggleChange(e, analyticsEventUI),
        label: formatMessage((0, $eCMal.default).digestsNotificationsReceiveNotificationsEmail),
        testId: "personal-settings-digest-notifications.common.ui.email-inviter-notif.notify-via-email-checkbox"
    })));
};

});
parcelRegister("jXdym", function(module, exports) {

$parcel$export(module.exports, "default", () => $33730287b5691b37$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<8001fc8c6d0ee3d57cc801dfc8a49908>>
 * @relayHash 79093d95234bb37c9805ad40ab86c1d7
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b6cc83458dddd26949a1d2c41df7db3c9d1a965af96dc7e25b67c5090f7e5216
const $33730287b5691b37$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isEnabled"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "fields": [
                {
                    "items": [
                        {
                            "fields": [
                                {
                                    "kind": "Literal",
                                    "name": "channel",
                                    "value": "EMAIL"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "isEnabled",
                                    "variableName": "isEnabled"
                                },
                                {
                                    "kind": "Literal",
                                    "name": "type",
                                    "value": "PROJECT_INVITER_NOTIFICATION"
                                }
                            ],
                            "kind": "ObjectValue",
                            "name": "preferences.0"
                        }
                    ],
                    "kind": "ListValue",
                    "name": "preferences"
                }
            ],
            "kind": "ObjectValue",
            "name": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "emailInviterNotificationMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraUpdateGlobalPreferencesPayload",
                            "kind": "LinkedField",
                            "name": "updateGlobalNotificationPreferences",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraNotificationPreferences",
                                    "kind": "LinkedField",
                                    "name": "preferences",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "emailInviterNotif_personalSettingsDigestNotifications_EmailInviterNotification"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "emailInviterNotificationMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraUpdateGlobalPreferencesPayload",
                            "kind": "LinkedField",
                            "name": "updateGlobalNotificationPreferences",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraNotificationPreferences",
                                    "kind": "LinkedField",
                                    "name": "preferences",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraNotificationPreference",
                                            "kind": "LinkedField",
                                            "name": "projectInviterNotification",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "id"
                                                },
                                                {
                                                    "concreteType": "JiraNotificationChannel",
                                                    "kind": "LinkedField",
                                                    "name": "emailChannel",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "isEnabled"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "b6cc83458dddd26949a1d2c41df7db3c9d1a965af96dc7e25b67c5090f7e5216",
            "metadata": {},
            "name": "emailInviterNotificationMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$33730287b5691b37$var$node.hash = "4fbb51707da54cc36a75a94c102438ef";
var $33730287b5691b37$export$2e2bcd8739ae039 = $33730287b5691b37$var$node;

});

parcelRegister("hj92z", function(module, exports) {

$parcel$export(module.exports, "default", () => $65651ad2d6294a6d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<735b2fd1299daeb15bae555ae1aef4fb>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $65651ad2d6294a6d$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "emailInviterNotif_personalSettingsDigestNotifications_EmailInviterNotification",
    "selections": [
        {
            "concreteType": "JiraNotificationPreference",
            "kind": "LinkedField",
            "name": "projectInviterNotification",
            "plural": false,
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "kind": "ScalarField",
                        "name": "id"
                    },
                    "action": "THROW",
                    "path": "projectInviterNotification.id"
                },
                {
                    "concreteType": "JiraNotificationChannel",
                    "kind": "LinkedField",
                    "name": "emailChannel",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isEnabled"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraNotificationPreferences"
};
$65651ad2d6294a6d$var$node.hash = "e5e47275b0e85a9af56402c3ffb07193";
var $65651ad2d6294a6d$export$2e2bcd8739ae039 = $65651ad2d6294a6d$var$node;

});


parcelRegister("2qfiH", function(module, exports) {

$parcel$export(module.exports, "InProductInviterNotification", () => $38ec7b58956ccd9d$export$e91a101e672370c2);

var $946eT = parcelRequire("946eT");

var $iAAGM = parcelRequire("iAAGM");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $c0aEF = parcelRequire("c0aEF");

var $2x3Cb = parcelRequire("2x3Cb");

var $kkJfY = parcelRequire("kkJfY");

var $2NMNM = parcelRequire("2NMNM");

var $jDrwg = parcelRequire("jDrwg");

var $koVbs = parcelRequire("koVbs");

var $koeKL = parcelRequire("koeKL");

var $jcw0u = parcelRequire("jcw0u");

var $9InRy = parcelRequire("9InRy");

var $8zOmE = parcelRequire("8zOmE");

var $eCMal = parcelRequire("eCMal");
const $38ec7b58956ccd9d$export$e91a101e672370c2 = ({ preferenceFragment: preferenceFragment })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const cloudId = (0, $koeKL.useCloudId)();
    const { showErrorFlag: showErrorFlag } = (0, $9InRy.useShowErrorFlag)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const data = (0, $8Uumt.useFragment)((0, $iAAGM.default), preferenceFragment);
    const [commit] = (0, $8Uumt.useMutation)((0, $946eT.default));
    const [debouncedHandleToggleChange] = (0, $jDrwg.default)((e, analyticsEventUI)=>{
        const newValue = e.currentTarget.checked;
        (0, $8zOmE.fireUIAnalytics)(analyticsEventUI, 'toggleInviterNotificationSwitch', {
            isToggleOn: newValue,
            channel: 'inProduct'
        });
        commit({
            variables: {
                cloudId: cloudId,
                isEnabled: newValue
            },
            optimisticResponse: {
                jira: {
                    updateGlobalNotificationPreferences: {
                        success: true,
                        errors: [],
                        preferences: {
                            projectInviterNotification: {
                                id: data.projectInviterNotification?.id ?? '',
                                inProductChannel: {
                                    isEnabled: newValue
                                }
                            }
                        }
                    }
                }
            },
            onError: (error)=>{
                showErrorFlag();
                (0, $jcw0u.default)({
                    meta: {
                        id: 'mutateInProductInviterNotification',
                        packageName: 'jiraPersonalSettingsNotificationsDigests',
                        teamName: 'jira-warepil'
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
            },
            onCompleted: (response)=>{
                const errors = response?.jira?.updateGlobalNotificationPreferences?.errors;
                if (errors && errors.length > 0) {
                    showErrorFlag();
                    errors.forEach((error)=>{
                        (0, $jcw0u.default)({
                            meta: {
                                id: 'mutateInProductInviterNotificationCompletedError',
                                packageName: 'jiraPersonalSettingsNotificationsDigests',
                                teamName: 'jira-warepil'
                            },
                            error: new Error(error?.message || 'Unknown Error'),
                            sendToPrivacyUnsafeSplunk: true
                        });
                    });
                } else (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'mutateInProductInviterNotification success');
            }
        });
    }, 300, {
        leading: true,
        trailing: true
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2x3Cb.Label), {
        htmlFor: "notify-via-in-product-checkbox"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c0aEF.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kkJfY.default), {
        isChecked: !!data.projectInviterNotification?.inProductChannel?.isEnabled,
        onChange: (e, analyticsEventUI)=>debouncedHandleToggleChange(e, analyticsEventUI),
        label: formatMessage((0, $eCMal.default).digestsNotificationsReceiveNotificationsInProduct),
        testId: "personal-settings-digest-notifications.common.ui.in-product-inviter-notif.notify-via-in-product-checkbox"
    })));
};

});
parcelRegister("946eT", function(module, exports) {

$parcel$export(module.exports, "default", () => $ecc47e15d46c763e$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<cbd7383fea06c8eca5c5f3d69f6856bc>>
 * @relayHash e5de3a9b6facebd1568f0561d8175770
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID fe1635716f814f40c4fea09db4afcccabd7b69f511bd75ebd62f991a8851389f
const $ecc47e15d46c763e$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isEnabled"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "fields": [
                {
                    "items": [
                        {
                            "fields": [
                                {
                                    "kind": "Literal",
                                    "name": "channel",
                                    "value": "IN_PRODUCT"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "isEnabled",
                                    "variableName": "isEnabled"
                                },
                                {
                                    "kind": "Literal",
                                    "name": "type",
                                    "value": "PROJECT_INVITER_NOTIFICATION"
                                }
                            ],
                            "kind": "ObjectValue",
                            "name": "preferences.0"
                        }
                    ],
                    "kind": "ListValue",
                    "name": "preferences"
                }
            ],
            "kind": "ObjectValue",
            "name": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "inProductInviterNotificationMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraUpdateGlobalPreferencesPayload",
                            "kind": "LinkedField",
                            "name": "updateGlobalNotificationPreferences",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraNotificationPreferences",
                                    "kind": "LinkedField",
                                    "name": "preferences",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "inProductInviterNotif_personalSettingsDigestNotifications_InProductInviterNotification"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "inProductInviterNotificationMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraUpdateGlobalPreferencesPayload",
                            "kind": "LinkedField",
                            "name": "updateGlobalNotificationPreferences",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraNotificationPreferences",
                                    "kind": "LinkedField",
                                    "name": "preferences",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraNotificationPreference",
                                            "kind": "LinkedField",
                                            "name": "projectInviterNotification",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "id"
                                                },
                                                {
                                                    "concreteType": "JiraNotificationChannel",
                                                    "kind": "LinkedField",
                                                    "name": "inProductChannel",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "isEnabled"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "fe1635716f814f40c4fea09db4afcccabd7b69f511bd75ebd62f991a8851389f",
            "metadata": {},
            "name": "inProductInviterNotificationMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$ecc47e15d46c763e$var$node.hash = "ef75a99451e568681ca1ab673b52975e";
var $ecc47e15d46c763e$export$2e2bcd8739ae039 = $ecc47e15d46c763e$var$node;

});

parcelRegister("iAAGM", function(module, exports) {

$parcel$export(module.exports, "default", () => $e0f3d9eacdc158c7$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2079850f542ae8af0b1c072e746e49b5>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $e0f3d9eacdc158c7$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "inProductInviterNotif_personalSettingsDigestNotifications_InProductInviterNotification",
    "selections": [
        {
            "concreteType": "JiraNotificationPreference",
            "kind": "LinkedField",
            "name": "projectInviterNotification",
            "plural": false,
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "kind": "ScalarField",
                        "name": "id"
                    },
                    "action": "THROW",
                    "path": "projectInviterNotification.id"
                },
                {
                    "concreteType": "JiraNotificationChannel",
                    "kind": "LinkedField",
                    "name": "inProductChannel",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isEnabled"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraNotificationPreferences"
};
$e0f3d9eacdc158c7$var$node.hash = "d50055f2472657ee6443df4182ea21bb";
var $e0f3d9eacdc158c7$export$2e2bcd8739ae039 = $e0f3d9eacdc158c7$var$node;

});


parcelRegister("bPkXX", function(module, exports) {

$parcel$export(module.exports, "SlackInviterNotification", () => $134d0ce8527986d0$export$5db7e101fa4e75c2);

var $6ydX9 = parcelRequire("6ydX9");

var $ldw13 = parcelRequire("ldw13");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $c0aEF = parcelRequire("c0aEF");

var $2x3Cb = parcelRequire("2x3Cb");

var $kkJfY = parcelRequire("kkJfY");

var $2NMNM = parcelRequire("2NMNM");

var $jDrwg = parcelRequire("jDrwg");

var $koVbs = parcelRequire("koVbs");

var $koeKL = parcelRequire("koeKL");

var $jcw0u = parcelRequire("jcw0u");

var $9InRy = parcelRequire("9InRy");

var $8zOmE = parcelRequire("8zOmE");

var $eCMal = parcelRequire("eCMal");
const $134d0ce8527986d0$export$5db7e101fa4e75c2 = ({ preferenceFragment: preferenceFragment })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const cloudId = (0, $koeKL.useCloudId)();
    const { showErrorFlag: showErrorFlag } = (0, $9InRy.useShowErrorFlag)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const data = (0, $8Uumt.useFragment)((0, $ldw13.default), preferenceFragment);
    const [commit] = (0, $8Uumt.useMutation)((0, $6ydX9.default));
    const [debouncedHandleToggleChange] = (0, $jDrwg.default)((e, analyticsEventUI)=>{
        const newValue = e.currentTarget.checked;
        (0, $8zOmE.fireUIAnalytics)(analyticsEventUI, 'toggleInviterNotificationSwitch', {
            isToggleOn: newValue,
            channel: 'slack'
        });
        commit({
            variables: {
                cloudId: cloudId,
                isEnabled: newValue
            },
            optimisticResponse: {
                jira: {
                    updateGlobalNotificationPreferences: {
                        success: true,
                        errors: [],
                        preferences: {
                            projectInviterNotification: {
                                id: data.projectInviterNotification?.id ?? '',
                                slackChannel: {
                                    isEnabled: newValue
                                }
                            }
                        }
                    }
                }
            },
            onError: (error)=>{
                showErrorFlag();
                (0, $jcw0u.default)({
                    meta: {
                        id: 'mutateSlackInviterNotification',
                        packageName: 'jiraPersonalSettingsNotificationsDigests',
                        teamName: 'jira-warepil'
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
            },
            onCompleted: (response)=>{
                const errors = response?.jira?.updateGlobalNotificationPreferences?.errors;
                if (errors && errors.length > 0) {
                    showErrorFlag();
                    errors.forEach((error)=>{
                        (0, $jcw0u.default)({
                            meta: {
                                id: 'mutateSlackInviterNotificationCompletedError',
                                packageName: 'jiraPersonalSettingsNotificationsDigests',
                                teamName: 'jira-warepil'
                            },
                            error: new Error(error?.message || 'Unknown Error'),
                            sendToPrivacyUnsafeSplunk: true
                        });
                    });
                } else (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'mutateSlackInviterNotification success');
            }
        });
    }, 300, {
        leading: true,
        trailing: true
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2x3Cb.Label), {
        htmlFor: "notify-via-slack-checkbox"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c0aEF.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kkJfY.default), {
        isChecked: !!data.projectInviterNotification?.slackChannel?.isEnabled,
        onChange: (e, analyticsEventUI)=>debouncedHandleToggleChange(e, analyticsEventUI),
        label: formatMessage((0, $eCMal.default).digestsNotificationsReceiveNotificationsSlack),
        testId: "personal-settings-digest-notifications.common.ui.slack-inviter-notif.notify-via-slack-checkbox"
    })));
};

});
parcelRegister("6ydX9", function(module, exports) {

$parcel$export(module.exports, "default", () => $082659cdcad08711$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<fc907df9b725f7b8e28ba03cd7adb459>>
 * @relayHash 1b8d0a8713ed0e6d36ca3f1051127589
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 581152a666d4ec48c9f4eed3434a0d5f670a46565b37ca202a69a0e8fe145a8f
const $082659cdcad08711$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isEnabled"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "fields": [
                {
                    "items": [
                        {
                            "fields": [
                                {
                                    "kind": "Literal",
                                    "name": "channel",
                                    "value": "SLACK"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "isEnabled",
                                    "variableName": "isEnabled"
                                },
                                {
                                    "kind": "Literal",
                                    "name": "type",
                                    "value": "PROJECT_INVITER_NOTIFICATION"
                                }
                            ],
                            "kind": "ObjectValue",
                            "name": "preferences.0"
                        }
                    ],
                    "kind": "ListValue",
                    "name": "preferences"
                }
            ],
            "kind": "ObjectValue",
            "name": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "slackInviterNotificationMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraUpdateGlobalPreferencesPayload",
                            "kind": "LinkedField",
                            "name": "updateGlobalNotificationPreferences",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraNotificationPreferences",
                                    "kind": "LinkedField",
                                    "name": "preferences",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "slackInviterNotif_personalSettingsDigestNotifications_SlackInviterNotification"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "slackInviterNotificationMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraUpdateGlobalPreferencesPayload",
                            "kind": "LinkedField",
                            "name": "updateGlobalNotificationPreferences",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraNotificationPreferences",
                                    "kind": "LinkedField",
                                    "name": "preferences",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraNotificationPreference",
                                            "kind": "LinkedField",
                                            "name": "projectInviterNotification",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "id"
                                                },
                                                {
                                                    "concreteType": "JiraNotificationChannel",
                                                    "kind": "LinkedField",
                                                    "name": "slackChannel",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "isEnabled"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "581152a666d4ec48c9f4eed3434a0d5f670a46565b37ca202a69a0e8fe145a8f",
            "metadata": {},
            "name": "slackInviterNotificationMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$082659cdcad08711$var$node.hash = "0107d8fde7db2faf58350b7b99452f18";
var $082659cdcad08711$export$2e2bcd8739ae039 = $082659cdcad08711$var$node;

});

parcelRegister("ldw13", function(module, exports) {

$parcel$export(module.exports, "default", () => $8efcfa9db1bea6e2$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<76040c0c3cdf82c6ffda2c06fea217eb>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $8efcfa9db1bea6e2$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "slackInviterNotif_personalSettingsDigestNotifications_SlackInviterNotification",
    "selections": [
        {
            "concreteType": "JiraNotificationPreference",
            "kind": "LinkedField",
            "name": "projectInviterNotification",
            "plural": false,
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "kind": "ScalarField",
                        "name": "id"
                    },
                    "action": "THROW",
                    "path": "projectInviterNotification.id"
                },
                {
                    "concreteType": "JiraNotificationChannel",
                    "kind": "LinkedField",
                    "name": "slackChannel",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isEnabled"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraNotificationPreferences"
};
$8efcfa9db1bea6e2$var$node.hash = "9413b48e94223170556a58bfbece4314";
var $8efcfa9db1bea6e2$export$2e2bcd8739ae039 = $8efcfa9db1bea6e2$var$node;

});


parcelRegister("c7kve", function(module, exports) {

$parcel$export(module.exports, "SlackPrefDueDateNotification", () => $ce562f51ce83f311$export$2932297bab0193ff);

var $9JfDE = parcelRequire("9JfDE");

var $hHW46 = parcelRequire("hHW46");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $c0aEF = parcelRequire("c0aEF");

var $2x3Cb = parcelRequire("2x3Cb");

var $kkJfY = parcelRequire("kkJfY");

var $2NMNM = parcelRequire("2NMNM");

var $jDrwg = parcelRequire("jDrwg");

var $koVbs = parcelRequire("koVbs");

var $koeKL = parcelRequire("koeKL");

var $jcw0u = parcelRequire("jcw0u");

var $9InRy = parcelRequire("9InRy");

var $8zOmE = parcelRequire("8zOmE");

var $eCMal = parcelRequire("eCMal");
const $ce562f51ce83f311$export$2932297bab0193ff = ({ preferenceFragment: preferenceFragment })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const cloudId = (0, $koeKL.useCloudId)();
    const { showErrorFlag: showErrorFlag } = (0, $9InRy.useShowErrorFlag)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const data = (0, $8Uumt.useFragment)((0, $hHW46.default), preferenceFragment);
    const [commit] = (0, $8Uumt.useMutation)((0, $9JfDE.default));
    const [debouncedHandleToggleChange] = (0, $jDrwg.default)((e, analyticsEventUI)=>{
        const newValue = e.currentTarget.checked;
        (0, $8zOmE.fireUIAnalytics)(analyticsEventUI, 'toggleDueDateNotificationSwitch', {
            isToggleOn: newValue
        });
        commit({
            variables: {
                cloudId: cloudId,
                isEnabled: newValue
            },
            optimisticResponse: {
                jira: {
                    updateGlobalNotificationPreferences: {
                        success: true,
                        errors: [],
                        preferences: {
                            dailyDueDateNotification: {
                                id: data.dailyDueDateNotification?.id ?? '',
                                slackChannel: {
                                    isEnabled: newValue
                                }
                            }
                        }
                    }
                }
            },
            onError: (error)=>{
                showErrorFlag();
                (0, $jcw0u.default)({
                    meta: {
                        id: 'mutateSlackPrefDueDateNotification',
                        packageName: 'jiraPersonalSettingsNotificationsDigests',
                        teamName: 'frontier'
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
            },
            onCompleted: (response)=>{
                const errors = response?.jira?.updateGlobalNotificationPreferences?.errors;
                if (errors && errors.length > 0) {
                    showErrorFlag();
                    errors.forEach((error)=>{
                        (0, $jcw0u.default)({
                            meta: {
                                id: 'mutateSlackPrefDueDateNotificationCompletedError',
                                packageName: 'jiraPersonalSettingsNotificationsDigests',
                                teamName: 'frontier'
                            },
                            error: new Error(error?.message || 'Unknown Error'),
                            sendToPrivacyUnsafeSplunk: true
                        });
                    });
                } else (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'mutateSlackPrefDueDateNotification success');
            }
        });
    }, 300, {
        leading: true,
        trailing: true
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2x3Cb.Label), {
        htmlFor: "notify-via-slack-checkbox"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c0aEF.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kkJfY.default), {
        isChecked: !!data.dailyDueDateNotification?.slackChannel?.isEnabled,
        onChange: (e, analyticsEventUI)=>debouncedHandleToggleChange(e, analyticsEventUI),
        label: formatMessage((0, $eCMal.default).digestsNotificationsReceiveNotificationsSlack),
        testId: "personal-settings-digest-notifications.common.ui.slack-pref-due-date-notif.notify-via-slack-checkbox"
    })));
};

});
parcelRegister("9JfDE", function(module, exports) {

$parcel$export(module.exports, "default", () => $0e9c3b1d8678a6f6$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<eb18cc9a54fa7d5c63c85a6419101daa>>
 * @relayHash b80cf4f3a6df8ffc0e36255e8bd0804e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d8991abce77b125aecc31739cb2a49c58d82e23062c534bbba6c4e4545ba83b3
const $0e9c3b1d8678a6f6$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isEnabled"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "fields": [
                {
                    "items": [
                        {
                            "fields": [
                                {
                                    "kind": "Literal",
                                    "name": "channel",
                                    "value": "SLACK"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "isEnabled",
                                    "variableName": "isEnabled"
                                },
                                {
                                    "kind": "Literal",
                                    "name": "type",
                                    "value": "DAILY_DUE_DATE_NOTIFICATION"
                                }
                            ],
                            "kind": "ObjectValue",
                            "name": "preferences.0"
                        }
                    ],
                    "kind": "ListValue",
                    "name": "preferences"
                }
            ],
            "kind": "ObjectValue",
            "name": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "slackPrefDueDateNotificationMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraUpdateGlobalPreferencesPayload",
                            "kind": "LinkedField",
                            "name": "updateGlobalNotificationPreferences",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraNotificationPreferences",
                                    "kind": "LinkedField",
                                    "name": "preferences",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "slackPrefDueDateNotif_personalSettingsDigestNotifications_SlackPrefDueDateNotification"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "slackPrefDueDateNotificationMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraUpdateGlobalPreferencesPayload",
                            "kind": "LinkedField",
                            "name": "updateGlobalNotificationPreferences",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraNotificationPreferences",
                                    "kind": "LinkedField",
                                    "name": "preferences",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraNotificationPreference",
                                            "kind": "LinkedField",
                                            "name": "dailyDueDateNotification",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "id"
                                                },
                                                {
                                                    "concreteType": "JiraNotificationChannel",
                                                    "kind": "LinkedField",
                                                    "name": "slackChannel",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "isEnabled"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "d8991abce77b125aecc31739cb2a49c58d82e23062c534bbba6c4e4545ba83b3",
            "metadata": {},
            "name": "slackPrefDueDateNotificationMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$0e9c3b1d8678a6f6$var$node.hash = "73fcf4a7eaf36331b7cd1793b31ee2e0";
var $0e9c3b1d8678a6f6$export$2e2bcd8739ae039 = $0e9c3b1d8678a6f6$var$node;

});

parcelRegister("hHW46", function(module, exports) {

$parcel$export(module.exports, "default", () => $3e733c4f32345bbf$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5ba6a4e34aecf005bc4af17662eedbf9>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $3e733c4f32345bbf$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "slackPrefDueDateNotif_personalSettingsDigestNotifications_SlackPrefDueDateNotification",
    "selections": [
        {
            "concreteType": "JiraNotificationPreference",
            "kind": "LinkedField",
            "name": "dailyDueDateNotification",
            "plural": false,
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "kind": "ScalarField",
                        "name": "id"
                    },
                    "action": "THROW",
                    "path": "dailyDueDateNotification.id"
                },
                {
                    "concreteType": "JiraNotificationChannel",
                    "kind": "LinkedField",
                    "name": "slackChannel",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isEnabled"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraNotificationPreferences"
};
$3e733c4f32345bbf$var$node.hash = "6021938a32dc3367dd7ef33f5e5d30b9";
var $3e733c4f32345bbf$export$2e2bcd8739ae039 = $3e733c4f32345bbf$var$node;

});




parcelRegister("4dRjY", function(module, exports) {

$parcel$export(module.exports, "PRODUCT_START_MARK", () => $9953c23a4f71adac$export$8e54fca0a680fdfd);
$parcel$export(module.exports, "MarkProductStart", () => $9953c23a4f71adac$export$2a999c5f84501025);

var $x9xyg = parcelRequire("x9xyg");
const $9953c23a4f71adac$export$8e54fca0a680fdfd = 'PRODUCT_START';
const $9953c23a4f71adac$export$2a999c5f84501025 = ()=>{
    if (!false) {
        performance.clearMarks($9953c23a4f71adac$export$8e54fca0a680fdfd);
        (0, $x9xyg.setMark)($9953c23a4f71adac$export$8e54fca0a680fdfd);
    }
    return null;
};

});

parcelRegister("5rqex", function(module, exports) {

$parcel$export(module.exports, "checkAndEmitApdexSignal", () => $ab527e70454bab7e$export$3082c88b693a5230);
$parcel$export(module.exports, "default", () => $ab527e70454bab7e$export$2e2bcd8739ae039);
$parcel$export(module.exports, "baseDefaultProps", () => $ab527e70454bab7e$export$9b3029ee6188a41f);

var $5uXOq = parcelRequire("5uXOq");

var $99gkn = parcelRequire("99gkn");

var $aOr3t = parcelRequire("aOr3t");

var $1u4q7 = parcelRequire("1u4q7");

var $1AZST = parcelRequire("1AZST");

var $6G6w0 = parcelRequire("6G6w0");

var $3wLoG = parcelRequire("3wLoG");

var $gtdbK = parcelRequire("gtdbK");

var $zbAs4 = parcelRequire("zbAs4");

var $3B7oW = parcelRequire("3B7oW");
const $ab527e70454bab7e$export$3082c88b693a5230 = (appName, metricKey)=>{
    var emitSignal;
};
class $ab527e70454bab7e$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            isExpectedToHaveSsr: false,
            withMarks: [],
            extra: {},
            emitOnAnimationFrame: false
        };
    }
    render() {
        const { appName: appName, metricKey: metricKey, extra: extra, metric: metric, emitOnAnimationFrame: emitOnAnimationFrame } = this.props;
        $ab527e70454bab7e$export$3082c88b693a5230(appName, metricKey);
        const isUFODefined = (0, $1AZST.GlobalPageLoadExperience).loadingPageLoadId !== 'UNKNOWN';
        if (isUFODefined) (0, $zbAs4.addUFOSSRDoneAsFMPToInteraction)();
        if (metric) {
            // https://product-fabric.atlassian.net/browse/UFO-323
            (0, $gtdbK.addBM3SSRDoneAsFMPToInteraction)(metric);
            (0, $3B7oW.trackBM3FeatureFlagsAccessed)(metric);
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $99gkn.default), {
            data: extra
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aOr3t.UFOBM3TimingsToUFO), {
            marks: metric?.getData()?.marks,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            timings: metric?.getData()?.config?.timings
        }), isUFODefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3wLoG.StopUfo), {
            appName: appName,
            customData: extra,
            key: (0, $1u4q7.getInteractionId)().current
        }) : metric && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6G6w0.StopBrowserMetrics3), {
            metric: metric,
            customData: extra,
            emitOnAnimationFrame: emitOnAnimationFrame
        }));
    }
}
const $ab527e70454bab7e$export$9b3029ee6188a41f = $ab527e70454bab7e$export$2e2bcd8739ae039.defaultProps;

});
parcelRegister("aOr3t", function(module, exports) {

$parcel$export(module.exports, "getBm3Timings", () => $a3e67858f0c2f8da$export$f02972da195a43bb);
$parcel$export(module.exports, "UFOBM3TimingsToUFO", () => $a3e67858f0c2f8da$export$30f0b5e5acd268bf);
$parcel$export(module.exports, "addBM3TimingsToUFO", () => $a3e67858f0c2f8da$export$d93d677ef2f33c5c);

var $5uXOq = parcelRequire("5uXOq");

var $1tcYS = parcelRequire("1tcYS");

var $1u4q7 = parcelRequire("1u4q7");

var $bFU4G = parcelRequire("bFU4G");
function $a3e67858f0c2f8da$export$f02972da195a43bb(marks, timingConfigs) {
    const bm3Timings = {};
    if (!marks || !timingConfigs) return bm3Timings;
    timingConfigs.forEach((item)=>{
        if (!item.startMark || !item.endMark) return;
        const startTime = marks[item.startMark];
        if (!startTime) return;
        const endTime = marks[item.endMark];
        if (!endTime) return;
        bm3Timings[item.key] = {
            startTime: startTime,
            endTime: endTime
        };
    });
    return bm3Timings;
}
function $a3e67858f0c2f8da$export$30f0b5e5acd268bf({ marks: marks, timings: timings }) {
    const interactionContext = (0, $5uXOq.useContext)((0, $1tcYS.default));
    const interactionId = (0, $1u4q7.getInteractionId)().current;
    (0, $5uXOq.useMemo)(()=>{
        if (interactionContext != null && interactionId != null && marks != null && timings != null) {
            const interactionType = (0, $bFU4G.getCurrentInteractionType)(interactionId);
            if (interactionType === 'press') return;
            const bm3Timings = $a3e67858f0c2f8da$export$f02972da195a43bb(marks, timings);
            interactionContext.addCustomTimings(bm3Timings);
        }
    }, [
        interactionContext,
        interactionId,
        marks,
        timings
    ]);
    return null;
}
function $a3e67858f0c2f8da$export$d93d677ef2f33c5c(marks, timingsConfig) {
    const interactionId = (0, $1u4q7.getInteractionId)().current;
    if (interactionId) {
        const interactionType = (0, $bFU4G.getCurrentInteractionType)(interactionId);
        if (interactionType === 'press') return;
        const bm3Timings = $a3e67858f0c2f8da$export$f02972da195a43bb(marks, timingsConfig);
        (0, $bFU4G.addCustomTiming)(interactionId, [], bm3Timings);
    }
}

});

parcelRegister("6G6w0", function(module, exports) {

$parcel$export(module.exports, "StopBrowserMetrics3", () => $84d0d168ebb35c8a$export$575e93c0f9905999);

var $5uXOq = parcelRequire("5uXOq");

var $1tcYS = parcelRequire("1tcYS");

var $21pfT = parcelRequire("21pfT");

var $x9xyg = parcelRequire("x9xyg");

var $7N30e = parcelRequire("7N30e");

var $4dRjY = parcelRequire("4dRjY");

var $2SVPM = parcelRequire("2SVPM");

var $6b6Tk = parcelRequire("6b6Tk");

const $84d0d168ebb35c8a$var$emitMetrics = (metric, customData, stopTime)=>{
    (0, $2SVPM.setInitialPageLoadTimingFromPerformanceMarks)('batch-js-heritage.eval', 'jira.heritage_batch_file_eval:start', 'jira.heritage_batch_file_eval:end');
    if (stopTime !== undefined) metric.stop({
        customData: customData,
        stopTime: stopTime
    });
    else metric.stop({
        customData: customData
    });
    if ((0, $6b6Tk.isAutomaticExposureCollectionEnabled)()) (0, $7N30e.stopLowPriorityEventDelay)();
};
class $84d0d168ebb35c8a$export$575e93c0f9905999 extends (0, $5uXOq.Component) {
    componentDidMount() {
        const { metric: metric, customData: customData, emitOnAnimationFrame: emitOnAnimationFrame } = this.props;
        if (!metric) return;
        const start = (0, $21pfT.browserMetrics).getPageLoadMetric()?.getData()?.start || 0;
        (0, $x9xyg.setMark)('BROWSER_METRICS_TTI_START', {
            startTime: start
        });
        (0, $x9xyg.setMark)('BROWSER_METRICS_TTI_END');
        (0, $x9xyg.setMeasure)('BROWSER_METRICS_TTI', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_END');
        const bm3Data = metric.getData();
        if (emitOnAnimationFrame) {
            const stopTime = performance.now();
            (0, $2SVPM.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $4dRjY.PRODUCT_START_MARK), true);
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: stopTime
            });
            if (typeof queueMicrotask !== 'undefined') queueMicrotask(()=>{
                (0, $x9xyg.setMark)('BROWSER_METRICS_TTI_TASK_END');
                (0, $x9xyg.setMeasure)('BROWSER_METRICS_TTI_TASK', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_TASK_END');
            });
            requestAnimationFrame(()=>{
                metric.mark((0, $ce556f125dee8174$export$99c08ec92759c71c));
                (0, $x9xyg.setMark)((0, $ce556f125dee8174$export$99c08ec92759c71c));
                (0, $x9xyg.setMeasure)('BROWSER_METRICS_TTI_RAF', 'BROWSER_METRICS_TTI_START', (0, $ce556f125dee8174$export$99c08ec92759c71c));
                setTimeout(()=>{
                    $84d0d168ebb35c8a$var$emitMetrics(metric, customData, stopTime);
                }, 500);
            });
        } else {
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: performance.now()
            });
            (0, $2SVPM.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $4dRjY.PRODUCT_START_MARK), true);
            $84d0d168ebb35c8a$var$emitMetrics(metric, customData);
        }
    }
    static{
        this.contextType = (0, $1tcYS.default);
    }
    render() {
        return null;
    }
}

});
const $ce556f125dee8174$export$56940a9488e85199 = 'jira.fe.spa-';
const $ce556f125dee8174$export$45c4b6bf7935c69a = `${$ce556f125dee8174$export$56940a9488e85199}start`;
const $ce556f125dee8174$export$135c96ab5afee429 = 'ssr.spa.rendered';
const $ce556f125dee8174$export$ff834eccc35b9089 = 'appBundleReady';
const $ce556f125dee8174$export$86b05e34d462ead8 = 'prefetchApiReady';
const $ce556f125dee8174$export$d6a604a7d9a390fb = 'prefetchApiStart';
const $ce556f125dee8174$export$3ae43cc1782d058f = 'jswRenderStart';
const $ce556f125dee8174$export$363f6703ffa600be = 'jswCreateReduxStoreStart';
const $ce556f125dee8174$export$e87b74567b79c8 = 'jswCreateReduxStoreEnd';
const $ce556f125dee8174$export$99fe642459a8b02 = 'jswTransformCriticalDataStart';
const $ce556f125dee8174$export$ab1f5705fc8e0571 = 'jswTransformCriticalDataEnd';
const $ce556f125dee8174$export$8c3a9046da692c35 = 'jswReduxSoftwareAppLoadedStart';
const $ce556f125dee8174$export$5aa497d1efdcc5bf = 'jswReduxSoftwareAppLoadedEnd';
const $ce556f125dee8174$export$99c08ec92759c71c = 'tti-raf-mark';
const $ce556f125dee8174$export$48552baa9db8ce1d = 'tti-raf';


parcelRegister("3wLoG", function(module, exports) {

$parcel$export(module.exports, "StopUfo", () => $bc9c50f4292c4530$export$d91154f099475c5);

var $5uXOq = parcelRequire("5uXOq");

var $1tcYS = parcelRequire("1tcYS");

var $1AZST = parcelRequire("1AZST");
class $bc9c50f4292c4530$export$d91154f099475c5 extends (0, $5uXOq.Component) {
    componentDidMount() {
        const { customData: customData, appName: appName } = this.props;
        (0, $1AZST.GlobalPageLoadExperience).success({
            force: true,
            metadata: customData
        });
        const name = appName || (0, $1AZST.GlobalPageLoadExperience).loadingPageLoadId;
        if (name) this.context?.addApdex({
            key: name,
            stopTime: performance.now()
        });
    }
    static{
        this.contextType = (0, $1tcYS.default);
    }
    render() {
        return null;
    }
}

});

parcelRegister("gtdbK", function(module, exports) {

$parcel$export(module.exports, "addBM3SSRDoneAsFMPToInteraction", () => $9088c71f7c9189f4$export$bf239ac2bfb04967);

var $1u4q7 = parcelRequire("1u4q7");

var $bFU4G = parcelRequire("bFU4G");
function $9088c71f7c9189f4$export$bf239ac2bfb04967(metric) {
    const interactionId = (0, $1u4q7.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    const data = metric.getData();
    // Use BM3 SSR mark as FMP config for UFO if it exists, temporarily.
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const config = data?.config;
    if (config && data?.isInitial) (0, $bFU4G.addMetadata)(currentInteractionId, {
        __legacy__bm3ConfigSSRDoneAsFmp: config.ssr?.doneAsFmp || false
    });
}

});

parcelRegister("zbAs4", function(module, exports) {

$parcel$export(module.exports, "addUFOSSRDoneAsFMPToInteraction", () => $30d390cd1767d57f$export$e63862cd888fe05a);

var $1u4q7 = parcelRequire("1u4q7");

var $bFU4G = parcelRequire("bFU4G");

var $1AZST = parcelRequire("1AZST");
var $49z18 = parcelRequire("49z18");
async function $30d390cd1767d57f$export$e63862cd888fe05a() {
    const interactionId = (0, $1u4q7.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    // Use UFO SSR mark as FMP config for rUFO if it exists, temporarily.
    const data = await (0, $1AZST.GlobalPageLoadExperience).exportData();
    const fmpMark = data.metrics.marks.find((mark)=>mark.name === 'fmp') || (0, $49z18.payloadPublisher).ssr?.getDoneMark();
    if (data.initial && fmpMark) (0, $bFU4G.addMetadata)(currentInteractionId, {
        __legacy__ufoConfigSSRDoneAsFmp: true
    });
}

});

parcelRegister("3B7oW", function(module, exports) {

$parcel$export(module.exports, "trackBM3FeatureFlagsAccessed", () => $afa764d83f81f55e$export$f00f1e874ce869e9);

var $1u4q7 = parcelRequire("1u4q7");

var $y7eb2 = parcelRequire("y7eb2");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $afa764d83f81f55e$var$startsAsObject = (value)=>{
    try {
        if (value.charAt(0) === '{') return true;
    } catch (e) {
        return false;
    }
    return false;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $afa764d83f81f55e$var$isObject = (value)=>value && typeof value === 'object' && value.constructor === Object;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $afa764d83f81f55e$var$isString = (input)=>{
    let result;
    try {
        result = typeof input === 'string' || input instanceof String;
    } catch (err) {
        // swallow any errors
        result = false;
    }
    return result;
};
const $afa764d83f81f55e$export$7b4abba432e57989 = (value)=>$afa764d83f81f55e$var$isString(value) && $afa764d83f81f55e$var$startsAsObject(value) || $afa764d83f81f55e$var$isObject(value);
const $afa764d83f81f55e$export$fcc03ee4c944962f = (featureFlagValue)=>$afa764d83f81f55e$export$7b4abba432e57989(featureFlagValue) ? 'non_boolean' : featureFlagValue;
const $afa764d83f81f55e$export$d2818866b4acbea4 = new Map();
const $afa764d83f81f55e$export$f00f1e874ce869e9 = (metric)=>{
    const interactionId = (0, $1u4q7.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    const data = metric.getData();
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const config = data?.config;
    if (config && config?.featureFlags?.length) {
        const allFeatureFlags = (0, $y7eb2.default)();
        config.featureFlags.forEach((featureFlagName)=>{
            const value = allFeatureFlags[featureFlagName];
            if (value === undefined) return;
            const featureFlagValue = $afa764d83f81f55e$export$fcc03ee4c944962f(value);
            $afa764d83f81f55e$export$d2818866b4acbea4.set(featureFlagName, featureFlagValue);
        });
    }
};

});


parcelRegister("lL5b5", function(module, exports) {

$parcel$export(module.exports, "default", () => $07c2532655d93687$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $j0xEB = parcelRequire("j0xEB");

var $j2Jlg = parcelRequire("j2Jlg");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$07c2532655d93687$export$2e2bcd8739ae039 = ()=>{
    const { href: href = null } = (0, $j0xEB.default)() || {};
    if (href && !href.includes('login.jsp')) {
        const encodedRedirectUrl = encodeURIComponent(href);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j2Jlg.default), {
            url: `/login.jsp?os_destination=${encodedRedirectUrl}`
        });
    }
    return null;
};

});
parcelRegister("j2Jlg", function(module, exports) {

$parcel$export(module.exports, "default", () => $773e6f988af77e5c$export$2e2bcd8739ae039);

var $gKZoD = parcelRequire("gKZoD");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$773e6f988af77e5c$export$2e2bcd8739ae039 = ({ url: url })=>{
    (0, $gKZoD.di)(window);
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.location.assign(url);
    return null;
};

});


parcelRegister("9dbF6", function(module, exports) {

$parcel$export(module.exports, "SubProductUpdater", () => $5979c081afa32bfa$export$eb40d3df56aa5c53);

var $5uXOq = parcelRequire("5uXOq");

var $5h5Fg = parcelRequire("5h5Fg");

var $16v4H = parcelRequire("16v4H");

var $3iTiR = parcelRequire("3iTiR");

var $54I24 = parcelRequire("54I24");

var $8OHH4 = parcelRequire("8OHH4");
const $5979c081afa32bfa$export$eb40d3df56aa5c53 = ({ allowMonolithDeferral: allowMonolithDeferral = false, ...props })=>{
    const subProduct = (0, $8OHH4.isSubProductProps)(props) ? props.subProduct : (0, $16v4H.subProductFromProjectTypeForAnalytics)(props.projectType);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5h5Fg.default), {
        op: (0, $54I24.default),
        args: [
            subProduct,
            allowMonolithDeferral
        ]
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3iTiR.default), {
        subProduct: subProduct
    }));
};

});
parcelRegister("3iTiR", function(module, exports) {

$parcel$export(module.exports, "default", () => $1214b0731559b377$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $01Rn4 = parcelRequire("01Rn4");

var $hFChZ = parcelRequire("hFChZ");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$1214b0731559b377$export$2e2bcd8739ae039 = ({ subProduct: subProduct })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $01Rn4.default), {
        op: (0, $hFChZ.default),
        args: [
            subProduct
        ]
    });

});
parcelRegister("hFChZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $0e606430ead76cd8$export$2e2bcd8739ae039);

var $2YZCu = parcelRequire("2YZCu");

var $eusud = parcelRequire("eusud");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$0e606430ead76cd8$export$2e2bcd8739ae039 = (subProduct)=>{
    (0, $eusud.performGetRequest)(`/rest/internal/2/mauTag/${subProduct}`).catch((err)=>{
        (0, $2YZCu.default).safeErrorWithoutCustomerData('common.tag-mau.tag-mau-event', 'Error connecting to monolith mau tag endpoint', err);
    });
};

});


parcelRegister("54I24", function(module, exports) {

$parcel$export(module.exports, "default", () => $bcbbcd48ca398ed4$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/wrm/no-load-bridge

var $7T84i = parcelRequire("7T84i");
var $9B86Q = parcelRequire("9B86Q");
var $cQZXC = parcelRequire("cQZXC");


var $2YZCu = parcelRequire("2YZCu");

var $fjcgS = parcelRequire("fjcgS");
const $bcbbcd48ca398ed4$var$maybeDelayAndRace = (// @ts-expect-error - TS2304 - Cannot find name 'Deferred'.
maybeWaitPromise, getDefaultPromise, getRacePromise)=>maybeWaitPromise ? Promise.race([
        maybeWaitPromise.then(getDefaultPromise),
        getRacePromise()
    ]) : getDefaultPromise();
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$bcbbcd48ca398ed4$export$2e2bcd8739ae039 = async (subProduct, allowMonolithDeferral)=>{
    (0, $fjcgS.getAnalyticsWebClientPromise)().then((client)=>{
        client.setSubProduct(subProduct);
        if (subProduct === 'serviceDesk') client.setUIViewedAttributes({
            solutions: [
                (0, $86344d58e71e925a$export$c8b406ad8ee0dab9)
            ]
        });
        else client.removeUIViewedAttribute('solutions');
    });
    // IMPORTANT -
    // Until such time as all pre-TTI WRM loads are removed we find that waitForHeritage() then
    // loadBridgeStrict() is too slow, resulting in `subproduct:unknown` for analytics events.
    // In that same case however, profiling shows us that polling in loadBridgeWeak() somehow
    // resolves the same AMD code faster.
    // This is not well understood, but it does allow us to work around the issue by racing these
    // two techniques.
    // Once there is no pre-TTI WRM loads we the waitForHeritage() then loadBridgeStrict() does seem
    // to be faster such that we can remove the `Promise.race()`.
    /* eslint-disable jira/wrm/no-load-bridge */ $bcbbcd48ca398ed4$var$maybeDelayAndRace(allowMonolithDeferral ? (0, $cQZXC.waitForHeritage)() : null, ()=>(0, $7T84i.loadBridgeStrict)({
            name: 'jira/analytics/sub-product-resolver',
            wrmKeys: [
                'wrc!com.atlassian.jira.jira-client-analytics-plugin:analytics-web-client'
            ]
        }), ()=>(0, $9B86Q.loadBridgeWeak)({
            name: 'jira/analytics/sub-product-resolver'
        })).then((subProductResolver)=>{
        subProductResolver.setSubProduct(subProduct);
    }).catch((e)=>(0, $2YZCu.default).safeErrorWithoutCustomerData('common.analytics-sub-product.sub-product-updater', 'Error connecting to monolith sub product resolver', e));
/* eslint-enable jira/wrm/no-load-bridge */ };

});
const $86344d58e71e925a$export$c8b406ad8ee0dab9 = 'jiraServiceManagement';


parcelRegister("8OHH4", function(module, exports) {

$parcel$export(module.exports, "isSubProductProps", () => $701d07b56c3e3574$export$c3063d6d7a8c075f);
const $701d07b56c3e3574$export$c3063d6d7a8c075f = (props)=>'subProduct' in props && typeof props.subProduct === 'string';

});


parcelRegister("dtjX2", function(module, exports) {

$parcel$export(module.exports, "DigestsNotificationsPageTitle", () => $1f8662434fd6bedd$export$7202491b301ac683);

var $5uXOq = parcelRequire("5uXOq");

var $id7K0 = parcelRequire("id7K0");

var $koVbs = parcelRequire("koVbs");

var $abf1q = parcelRequire("abf1q");
const $1f8662434fd6bedd$export$7202491b301ac683 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $id7K0.DocumentTitle), {
        title: formatMessage((0, $abf1q.default).digestsPageTitle)
    });
};

});
parcelRegister("id7K0", function(module, exports) {

$parcel$export(module.exports, "DocumentTitle", () => $938046587fdeeb52$export$dd5ad0b65cf665da);

var $5uXOq = parcelRequire("5uXOq");

var $cSD7y = parcelRequire("cSD7y");

var $4CAXd = parcelRequire("4CAXd");
// eslint-disable-next-line jira/react/no-class-components
class $938046587fdeeb52$var$DocumentTitleOld extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            TitleSubscriber: (0, $4CAXd.DocumentTitleSubscriber)
        };
    }
    shouldComponentUpdate(nextProps) {
        return nextProps.title !== this.props.title;
    }
    render() {
        const { title: title, TitleSubscriber: TitleSubscriber = (0, $4CAXd.DocumentTitleSubscriber) } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(TitleSubscriber, null, ({ contextArray: contextArray }, { setTitle: setTitle, addDocumentTitle: addDocumentTitle, removeDocumentTitle: removeDocumentTitle })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4CAXd.DocumentTitleHelperOld), {
                title: title,
                setTitle: setTitle,
                addDocumentTitle: addDocumentTitle,
                contextArray: contextArray,
                removeDocumentTitle: removeDocumentTitle,
                TitleSubscriber: TitleSubscriber
            }));
    }
}
const $938046587fdeeb52$export$dd5ad0b65cf665da = (0, $cSD7y.componentWithFG)('jira-concurrent-document-title', (0, $4CAXd.DocumentTitleHelper), $938046587fdeeb52$var$DocumentTitleOld);

});

parcelRegister("abf1q", function(module, exports) {

$parcel$export(module.exports, "default", () => $88e1d494971f6aaa$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $88e1d494971f6aaa$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    digestsPageTitle: {
        "id": "spa-apps-personal-settings-digests-notifications.digests-page-title",
        "defaultMessage": "Digest Notifications"
    }
});

});




//# sourceMappingURL=async-personal-settings-digests.bbbe2bf0.js.map
